export default {
    address: {
        city: "Stad",
        city_locality: "Stad \/ Plaats",
        country: "Land",
        line1: "Adresregel 1",
        line2: "Adresregel 2",
        postal_code: "Postcode",
        state: "Provincie \/ Staat",
        state_region: "Staat \/ Regio"
    },
    alerts: {
        account_2fa: "Beveilig uw account met tweefactorauthenticatie.",
        account_2fa_success: "Tweefactorauthenticatie is ingeschakeld.",
        activate_instruction: "Als u het automatisch verzamelen van beoordelingen inschakelt, wordt geprobeerd een beoordeling op te vragen bij {count}. Bekijk uw sjablonen voordat u deze inschakelt.",
        activate_intro: "Vraag voortdurend om beoordelingen op basis van uw strategie.",
        agency_mcp_server: "Verbind Claude of een andere MCP client met de MCP server van uw bureau. Geautoriseerde assistenten kunnen namens u de projecten, klanten en het team van uw bureau beheren.",
        agency_sso: "Verbind een OpenID Connect-identiteitsprovider voor clientaanmelding.",
        ai_assistant: "Uw bedrijfsnaam en -beschrijving zijn vereist om AI te gebruiken voor beoordelingssuggesties en reacties.",
        api_key_roll: "Weet je zeker dat je je API sleutel wilt wijzigen? Dit heeft gevolgen voor alle applicaties die deze sleutel gebruiken.",
        ask_confirm: "Weet u zeker dat u reviews wilt aanvragen van {count}? Hiermee worden aanvragen gepland voor alle klanten die nog niet zijn gevraagd.",
        cname_delete: "Weet u zeker dat u CNAME: {cname_name} wilt verwijderen?",
        cname_not_configured: "Dit record is nog niet geconfigureerd. Even geduld alstublieft...",
        cname_warning: "Berichten die al naar uw klanten zijn verzonden, bevatten verbroken links.",
        connection_disabled: "Verbinding is uitgeschakeld. Maak opnieuw verbinding.",
        customer_archive: "Weet u zeker dat u de klant: {customer_name} wilt archiveren? Alle niet-verzonden berichten worden geannuleerd.",
        customer_cancel: "Weet u zeker dat u alle niet-verzonden berichten voor klant: {customer_name} wilt annuleren?",
        customer_ingest: "Voeg dit e-mailadres toe aan het BCC-veld wanneer u e-mails naar uw klanten stuurt, zodat hun naam en e-mailadres automatisch worden geïmporteerd.",
        customer_resubscribe: "Weet u zeker dat u de klant: {customer_name} opnieuw wilt abonneren?",
        customer_unarchive: "Weet u zeker dat u de klant {customer_name} wilt uitarchiveren?",
        customer_unsubscribe: "Weet u zeker dat u de klant: {customer_name} wilt afmelden?",
        customer_unsubscribe_all: "Weet u zeker dat u {count} wilt afmelden voor het ontvangen van berichten van dit project?",
        delete: "Weet u zeker dat u {model}: {name} wilt verwijderen?",
        delete_count: "Weet u zeker dat u {count} wilt verwijderen?",
        domain_agency: "Voeg uw eigen verzenddomein toe om uw bureau volledig 'white label' te maken.",
        domain_delete: "Weet u zeker dat u het domein: {name} wilt verwijderen? We blijven e-mails versturen vanaf onze eigen domeinnaam.",
        domain_dmarc: "Voeg een DMARC record toe aan uw domein om de kans te verkleinen dat e-mails in de spammap terechtkomen.",
        domain_project: "Voeg een verzenddomein toe, zodat we e-mails naar uw klanten kunnen versturen vanaf uw eigen domeinnaam.",
        export_confirm: "Weet u zeker dat u al uw {model} wilt exporteren?",
        export_count: "Weet u zeker dat u {count} wilt exporteren?",
        export_link: "Kort nadat u de aanvraag heeft ingediend, wordt er een downloadlink naar {email} verzonden.",
        highlights_save_disabled: "Je kunt er eventueel voor kiezen om markeringen te verwijderen uit alle beoordelingen die deze momenteel bevatten.",
        highlights_save_enabled: "Om alle positieve beoordelingen te markeren, vinkt u het onderstaande vakje aan. Als u alleen de kleur van de markering wilt wijzigen, laat u het vakje uitgevinkt.",
        integration_disconnect: "Weet u zeker dat u de verbinding met {integration_name} wilt verbreken?",
        integration_sync: "Weet u zeker dat u uw {integration_name} account wilt synchroniseren? Wij importeren uw gegevens continu voor u.",
        intro: "Klaar om meer positieve beoordelingen van je klanten te ontvangen? Importeer je klanten om te beginnen. Vraag vervolgens handmatig om beoordelingen of druk op de knop 'Automatiseren' en laat de beoordelingen binnenstromen.",
        logout: "Weet u zeker dat u wilt uitloggen?",
        mcp_server: "Verbind Claude of een andere MCP client met dit project. De MCP server stelt AI-assistenten in staat om namens u beoordelingen, klanten en berichten te lezen en te beheren.",
        member_confirm: "Weet u zeker dat u uzelf wilt verwijderen? U verliest dan de toegang tot dit project.",
        member_confirm_all: "Weet u zeker dat u uzelf wilt verwijderen? U verliest dan de toegang tot al uw projecten.",
        member_other_confirm: "Weet u zeker dat u de {noun}: {name} wilt verwijderen? Ze verliezen dan de toegang tot dit project.",
        member_other_confirm_all: "Weet u zeker dat u de {noun} {name} wilt verwijderen? Ze verliezen dan toegang tot al hun projecten.",
        message_cancel: "Weet u zeker dat u dit bericht wilt annuleren?",
        message_cancel_all: "Weet u zeker dat u {count} wilt annuleren? Deze actie kan alleen worden uitgevoerd op niet-verzonden berichten.",
        message_delete: "Weet u zeker dat u dit bericht wilt verwijderen?",
        oauth_client_revoke: "Weet u zeker dat u de toegang voor {client} wilt intrekken? Alle actieve sessies worden onmiddellijk verbroken.",
        project_summary: "Er kan op dit moment geen samenvatting worden gegenereerd.",
        project_suspend: "Weet u zeker dat u het project {project_name} wilt onderbreken?",
        project_unsuspend: "Weet u zeker dat u het project {project_name} wilt hervatten?",
        review_delete: "Weet u zeker dat u deze review wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        review_page_confirm: "Weet u zeker dat u uw wijzigingen wilt opslaan?",
        review_page_confirmation: "Toon een bevestigingsbericht op de succespagina op basis van de geselecteerde beoordeling.",
        review_page_default: "Weet u zeker dat u de reviewpagina: {name} uw standaardpagina wilt maken? Deze pagina wordt gebruikt als er geen andere pagina is toegewezen aan een reviewverzoek.",
        review_page_delete: "Weet u zeker dat u de beoordelingspagina: {name} wilt verwijderen? Alle klanten die momenteel naar deze pagina worden geleid, worden naar uw standaardpagina geleid.",
        review_page_delete_all: "Weet u zeker dat u {count} wilt verwijderen? Uw standaard beoordelingspagina wordt niet verwijderd.",
        review_page_fields: "Gebruik velden om klantgegevens vast te leggen wanneer u een beoordeling achterlaat. Voeg meer velden toe aan uw formulier en geef ze voorwaardelijk weer wanneer klanten een beoordeling selecteren.",
        review_page_instructions: "Toon instructies direct boven het formulier nadat u een beoordeling hebt geselecteerd.",
        review_page_location_picker: "Laat klanten een locatie in uw project selecteren voor de review. Dit wordt vooraf geselecteerd als de reviewpagina bedoeld is om te worden weergegeven voor een specifieke locatie.",
        review_page_locations: "Selecteer de locaties die deze reviewpagina moeten gebruiken. Een locatie kan slechts aan één reviewpagina worden toegewezen. Als een locatie niet aan één is toegewezen, wordt de standaard reviewpagina gebruikt.",
        review_page_redirects: "Sla het formulier over nadat een beoordeling is geselecteerd en stuur het ergens anders naartoe. U kunt het verkeer ook naar meerdere websites splitsen door meer dan één omleiding voor elke beoordeling toe te voegen.",
        share_template_delete: "Weet je zeker dat je de deelsjabloon \"{name}\" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        smtp_remove: "Weet u zeker dat u de SMTP configuratie uit uw project wilt verwijderen? Uw verzendende domein zal terugvallen op de standaardconfiguratie.",
        smtp_setup: "Verstuur e-mails vanaf uw eigen mailserver. Voer uw SMTP gegevens in. Als uw server IP-beperkingen hanteert, voeg dan de volgende IP's toe aan uw whitelist die door ons systeem worden gebruikt: {ips}.",
        space_delete: "Weet u zeker dat u de werkruimte: {name} wilt verwijderen? Alle projecten daarin worden verwijderd.",
        tag_rule: "Voeg een positieve term en zijn negatieve tegenhanger toe. Als het van toepassing is, gebruiken we AI om de review automatisch te taggen met de ene of de andere.",
        user_delete: "Weet u zeker dat u het gebruikersaccount voor: {email} wilt verwijderen?",
        user_verify: "Om uw e-mailadres te verifiëren en uw account te activeren, klikt u op de link in de e-mail die is verzonden naar: {email}.",
        widget_delete: "Weet u zeker dat u de widget: {name} wilt verwijderen? De widget wordt dan op geen enkele website meer weergegeven.",
        widget_restore: "Weet u zeker dat u de instellingen voor widget: {name} wilt herstellen? Alleen het ontwerp wordt teruggezet naar de standaardwaarden.",
        widgets_1: "Voeg dit script toe aan de hoofdtekst van uw website.",
        widgets_2: "De Beoordelingsmuur toont al uw beoordelingen in een raster. Voeg dit script toe waar u de widget wilt weergeven.",
        widgets_3: "De Uitgelichte beoordeling toont één grote beoordeling. Voeg dit script toe waar u de widget wilt weergeven."
    },
    billing_statuses: {
        active: "Je abonnement is actief.",
        canceled: "Je abonnement is geannuleerd. Upgrade je abonnement om verder te gaan.",
        ending: "Je abonnement eindigt op {date}.",
        trial: "Je gratis proefperiode eindigt op {date}.",
        trial_expired: "Je gratis proefperiode is afgelopen. Upgrade je abonnement om verder te gaan.",
        trial_expiring: "Je gratis proefperiode loopt binnenkort af. Upgrade je abonnement om verder te gaan."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Voeg een verzenddomein toe om uw e-mailadres te bewerken:",
        agency_robots: "Geef zoekmachines toestemming om uw klantenportaal te indexeren.",
        ai_business_description: "Een gedetailleerde beschrijving van uw bedrijf, zodat u suggesties voor beoordelingen en reacties kunt genereren.",
        ai_business_name: "De naam van uw bedrijf.",
        ask_location: "De locatie die aan de beoordeling moet worden toegewezen.",
        ask_review_page: "De pagina waarop de recensie wordt vastgelegd.",
        assign_tags: "Wijs tags toe aan de beoordeling.",
        csv_max_rows: "Tot {count} Rijen",
        dashboard_configure_settings: "Configureer uw projectinstellingen.",
        dashboard_import_customers: "Importeer uw klanten.",
        dashboard_preview_email_templates: "Bekijk een voorbeeld van uw e-mailsjablonen.",
        dashboard_preview_kiosk_page: "Bekijk een voorbeeld van uw kioskpagina.",
        dashboard_preview_review_page: "Bekijk een voorbeeld van uw beoordelingspagina.",
        dashboard_preview_showcase_page: "Bekijk een voorbeeld van uw showcasepagina.",
        logo_height: "De hoogte van het logo op e-mails en pagina's.",
        meta_description: "De paginabeschrijving negeren.",
        meta_title: "Vervang de paginatitel.",
        mfa_password: "Voer het wachtwoord van uw account in.",
        mfa_qr_code: "Scan de QR-code met uw authenticator-app.",
        mfa_security_code: "Voer de code van uw authenticator-app in.",
        override_ambassador: "Plaats een badge in de e-mails, op de pagina's en in de widgets van uw klanten.",
        project_name: "De naam van uw bedrijf, merk of website.",
        project_robots: "Geef zoekmachines de mogelijkheid om uw beoordelingspagina's te indexeren en te presenteren.",
        project_slug: "Wordt gebruikt in e-mails en links voor klanten als er geen CNAME is geconfigureerd.",
        review_page_copied_message: "Wordt weergegeven nadat er een positieve beoordeling is ingediend.",
        review_page_email_address: "Ontvang beoordelingen via dit e-mailadres.",
        review_page_link_reveal_position: "Waar de links zichtbaar zijn.",
        review_page_link_revealer_label: "Het label om de links te onthullen.",
        review_page_link_revealer_rating: "Geef links weer als de klant deze beoordeling of hoger kiest. Anders wordt er een knop weergegeven om de links weer te geven.",
        review_page_native_reviews: "Sta beoordelingen toe op dit platform.",
        review_page_rating_selection: "Sla de score op voordat een beoordeling wordt ingediend.",
        review_page_success_button_link: "Als dit veld leeg is, wordt de link standaard naar de website van uw project gestuurd. Anders wordt de link naar het domein van de pagina gestuurd.",
        review_page_warning: "Als u klanten verhindert openbare beoordelingen achter te laten, kan uw bedrijfsvermelding worden verwijderd.",
        review_reply_status: "We kunnen niet publiekelijk reageren op deze recensie. U kunt in plaats daarvan rechtstreeks contact opnemen met de recensent.",
        review_suggestions: "Help klanten bij het schrijven van beoordelingen.",
        separate_with_commas: "Scheid meerdere woorden met komma's.",
        setup_basics: "Bepaal wanneer en hoe je klanten om beoordelingen vraagt.",
        setup_business: "Vertel ons onder welke naam uw klanten u kennen.",
        setup_google: "Stuur klanten door naar je Google profiel, reageer op beoordelingen en importeer bestaande recensies. Je kunt deze stap overslaan en later doen.",
        setup_location_limit: "Je proefperiode omvat 1 locatie. Je kunt op elk gewenst moment upgraden om meer locaties te synchroniseren.",
        showcase_locations: "Beperk de showcase tot specifieke locaties.",
        showcase_review_length: "Beoordelingen moeten minimaal zoveel tekens zijn.",
        showcase_since: "Toon beoordelingen die op of vóór deze datum zijn gemaakt.",
        showcase_sources: "Beperk de showcase tot specifieke bronnen.",
        showcase_tags: "Beperk de showcase tot beoordelingen met specifieke tags.",
        signature_html: "Kopieer en plak de handtekening in uw e-mailprogramma.",
        signed_up: "De startdatum van de klant.",
        twilio_webhook: "Stel in als de callback- URL voor uw berichten-service.",
        widget_embed: "Het ID -kenmerk van de div-container waarin de widget wordt weergegeven."
    },
    labels: {
        accept_all: "Alles accepteren",
        access_code: "Toegangscode",
        access_codes: "Toegangscodes",
        account: "Account",
        account_sid: "Account SID",
        action: "Actie",
        actions: "Acties",
        activate: "Activeren",
        active: "Actief",
        active_subscription: "Actief abonnement",
        add: "Toevoegen",
        add_agency_project: "Voeg een agentschapsproject toe",
        add_confirmation_message: "Voeg een bevestigingsbericht toe.",
        add_css_rules: "Voeg uw eigen CSS-regels toe.",
        add_custom_field: "Aangepast veld toevoegen",
        add_customer: "Voeg een klant toe",
        add_customers_with: "Klanten toevoegen met {model}",
        add_external_link: "Externe Koppeling toevoegen",
        add_external_links: "Externe Koppelingen toevoegen",
        add_introduction: "Voeg een inleiding toe.",
        add_js_tags: "Voeg uw eigen JavaScript tags toe.",
        add_legal_information: "Voeg juridische informatie toe.",
        add_location: "Voeg een locatie toe",
        add_project: "Een project toevoegen",
        add_review: "Voeg een Beoordeling toe",
        add_source: "Een bron toevoegen",
        add_tag: "Voeg een tag toe",
        added: "Toegevoegd",
        address: "Adres",
        advanced_review_pages: "Geavanceerde Beoordelingspagina’s",
        affiliates: "Gelieerde ondernemingen",
        age_of_reviews: "Leeftijd van Beoordelingen",
        agencies: "Bureaus",
        agency: "Bureau",
        agency_name: "Naam van het agentschap",
        agency_project: "Agentschapsproject",
        agency_projects: "Agentschapsprojecten",
        ai: "AI",
        ai_answers: "AI-antwoorden",
        ai_assistant: "AI-assistent",
        ai_auto_tagging: "AI-automatische tagging",
        ai_reviews_and_replies: "Suggesties en antwoorden van AI-reviews",
        ai_tagging_instructions: "Voorbeeld: Reageer op beoordelingen waarin wachttijden, trage service of vertragingen worden genoemd.",
        all: "Alle",
        allowed_domains: "Toegestane domeinen",
        amount: "Hoeveelheid",
        analytics: "Analyse",
        and: "En",
        anonymous_reviews: "Anonieme Beoordelingen",
        answer: "Antwoord",
        any: "Elk",
        api: "API",
        api_key: "API sleutel",
        appearance: "Verschijning",
        approved: "Goedgekeurd",
        archive: "Archief",
        archive_customer: "Klant archiveren",
        archived: "Gearchiveerd",
        at_least: "ten minste",
        at_least_days: "Minimaal {num} dagen",
        at_least_hours: "Tenminste {num} uur",
        at_least_months: "Minimaal {num} maanden",
        at_most: "hoogstens",
        at_most_days: "Maximaal {num} dagen",
        at_most_hours: "Maximaal {num} uur",
        at_most_months: "Maximaal {num} maanden",
        auth_token: "Auth-token",
        authorize: "Autoriseren",
        auto_detect: "Automatisch detecteren",
        auto_tags: "Auto-tags",
        automate: "Automatiseren",
        automate_highlights: "Markeringen automatiseren",
        automate_replies: "Automatische antwoorden",
        automatic_review_collection: "Automatische Beoordeling",
        automatically_apply_tags: "Automatisch tag toevoegen aan bestaande beoordelingen",
        automating: "Automatisering",
        avatar: "Avatar",
        avatars: "Avatars",
        average_charge: "Gemiddelde betaling",
        average_review: "Gemiddelde Beoordeling",
        background_color: "Achtergrondkleur",
        background_image: "Achtergrondafbeelding",
        back: "Rug",
        bcc: "BCC",
        bcc_email_address: "BCC -e-mailadres",
        best_to_worst: "Van beste naar slechtste",
        billing: "Facturering",
        blog: "Blog",
        body: "Tekst",
        body_font_size: "Lettergrootte van de Tekst",
        bold: "Vet",
        book_a_demo: "Demo boeken",
        bottom: "Onderkant",
        bottom_left: "Linksonder",
        bottom_right: "Rechtsonder",
        build_on: "Voortbouwen op {model}",
        business: "Business",
        business_description: "Bedrijfsbeschrijving",
        business_email: "Ondersteunings-e-mailadres",
        business_name: "Bedrijfsnaam",
        business_phone: "Ondersteuningstelefoonnummer",
        business_website: "Zakelijke website",
        button: "Knop",
        button_label: "Label voor Knop",
        button_link: "Koppeling voor Knop",
        button_position: "Positie van de Knop",
        button_size: "Grootte van de Knop",
        buy_me_a_coffee: "Koop mij een koffie",
        by: "door",
        by_signing_up: "Door een account aan te maken, ga je akkoord met onze voorwaarden.",
        call_to_action: "Oproep tot actie",
        cancel: "Annuleren",
        cancel_1_message: "Annuleer 1 bericht",
        cancel_message: "Bericht annuleren",
        cancel_messages: "Annuleer {count} berichten",
        cancel_subscription: "Abonnement opzeggen",
        cancel_unsent_messages: "Niet-verzonden berichten annuleren",
        canceled: "Geannuleerd",
        center: "Centrum",
        change: "Wijziging",
        change_key: "Uw API sleutel wijzigen",
        change_plan: "Wijzigingsplan",
        changelog: "Wijzigingslogboek",
        channel: "Kanaal",
        channels: "Kanalen",
        characters: "Tekens",
        charges_avg: "De gemiddelde Betaling moet minimaal zijn",
        charges_count: "Het aantal Betalingen moet minimaal zijn",
        charges_sum: "Het totale bedrag aan betalingen moet minimaal zijn",
        chat_with_us: "Chat met ons",
        checkbox: "Selectievakje",
        claude: "Claude",
        clear: "Duidelijk",
        clear_highlights_from_reviews: "Verwijder markeringen uit alle beoordelingen",
        clicked: "Geklikt",
        client: "Client",
        client_id: "Client ID",
        clients: "Klanten",
        close: "Dichtbij",
        cloudflare_warning: "Als u Cloudflare gebruikt, moet uw proxy uitgeschakeld zijn.",
        cname: "CNAME",
        cname_setup_incomplete: "Installatie onvolledig - wordt verwijderd op {date}",
        cname_ssl_pending: "SSL-certificaat in afwachting",
        cname_status_for: "CNAME status voor",
        code_editor: "Code-editor",
        collapse: "Inklappen",
        collect_reviews_anywhere: "Verzamel overal beoordelingen",
        color: "Kleur",
        colors: "Kleuren",
        commission_rate: "Commissiepercentage",
        commission_status_approved: "Goedgekeurd",
        commission_status_paid: "Betaald",
        commission_status_pending: "In behandeling",
        commission_status_reversed: "Teruggedraaid",
        community: "Gemeenschap",
        company: "Bedrijf",
        complained: "Geklaagd",
        confirm_new_password: "Bevestig nieuw wachtwoord",
        confirmation_message: "Bevestigingsbericht",
        connect: "Verbinden",
        connect_bank: "Koppel bankrekening",
        connect_google: "Verbinden met Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Aangesloten",
        consent_preferences: "Toestemmingsvoorkeuren",
        contact_customer: "Contact opnemen met klant",
        contact_form: "Contactformulier",
        contact_support: "Neem contact op met de ondersteuning.",
        contact_us: "Neem contact met ons op",
        container_element: "Containerelement",
        context: "Context",
        continue: "Doorgaan",
        continue_with_google: "Doorgaan met Google",
        cookie_category_analytics: "Analyses",
        cookie_category_essential: "Essentieel",
        cookie_category_functional: "Functioneel",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Cookie-toestemmingsbanner",
        cookie_consent_scope_all: "Laat het aan iedereen zien",
        cookie_consent_scope_eea: "Alleen toegankelijk voor bezoekers uit de EER en het VK.",
        cookie_consent_scope_none: "Niet weergeven",
        cookie_policy: "Cookiebeleid",
        cookie_preference: "Cookievoorkeuren",
        copied: "Gekopieerd",
        copied_message: "Gekopieerd bericht",
        copy: "Kopiëren",
        copy_embed_code: "Kopieer embedcode",
        copy_signature: "Kopie Handtekening",
        copy_source_code: "Broncode kopiëren",
        copy_to_all_ratings: "Kopiëren naar alle beoordelingen",
        copy_uuid: "Kopieer UUID",
        create: "Creëren",
        create_account: "Account aanmaken",
        create_agency: "Richt een agentschap op",
        create_cname: "Maak een CNAME record en wijs deze toe aan",
        create_external_link: "Een externe Koppeling maken",
        create_field: "Een veld aanmaken",
        create_link: "Een Koppeling maken",
        create_location: "Een locatie aanmaken",
        create_project: "Een project maken",
        create_qr_code: "Maak een QR-code aan",
        create_review: "Schrijf een Beoordeling",
        create_review_page: "Een Beoordelingspagina maken",
        create_signature: "Maak een handtekening aan",
        create_source: "Een bron maken",
        create_space: "Creëer een werkruimte",
        create_tag: "Tag aanmaken",
        create_tag_rule: "Tagregel aanmaken",
        create_webhook: "Een webhook maken",
        create_widget: "Een widget maken",
        crms: "CRMs",
        csv: "CSV",
        currency: "Munteenheid",
        current_plan: "Huidig plan",
        current_year: "Huidig jaar",
        custom_field: "Aangepast veld",
        custom_instructions: "Aangepaste instructies",
        custom_url: "Aangepaste URL",
        customer: "Klant",
        customer_name_convention: "Klantnaamconventie",
        customer_reviews: "Beoordelingen",
        customers: "Klanten",
        customize: "Aanpassen",
        customize_review_page: "Pas Beoordelingspagina aan",
        daily: "Dagelijks",
        daily_email_requests: "Dagelijkse e-mailverzoeken",
        daily_limit: "Dagelijkse limiet",
        daily_requests: "Dagelijkse verzoeken",
        daily_sms_requests: "Dagelijkse SMS verzoeken",
        dark: "Donker",
        dashboard: "Bedieningsoverzicht",
        date: "Datum",
        date_added: "Datum toegevoegd",
        date_canceled: "Datum geannuleerd",
        date_clicked: "Datum aangeklikt",
        date_complained: "Datum van de klacht",
        date_delivered: "Datum van levering",
        date_failed: "Datum mislukt",
        date_messaged: "Datum bericht",
        date_opened: "Datum geopend",
        date_replied: "Datum beantwoord",
        date_requested: "Datum aangevraagd",
        date_reviewed: "Datum Beoordeeld",
        date_scheduled: "Geplande datum",
        date_sent: "Datum verzonden",
        date_signed_up: "Datum van aanmelding",
        date_updated: "Datum bijgewerkt",
        dates: "Data",
        day: "Dag",
        days: "Dagen",
        days_after_last_request: "dagen na laatste verzoek",
        days_later: "dagen later",
        deactivate: "Deactiveren",
        default: "Standaard",
        default_language: "Standaardtaal",
        default_review_page: "Standaard Beoordelingspagina",
        default_review_visibility: "Standaard zichtbaarheid van Beoordeling",
        default_tone: "Standaardtoon",
        delay: "Vertraging",
        delete: "Verwijderen",
        delete_1_customer: "Verwijder 1 klant",
        delete_1_review: "Verwijder 1 Beoordeling",
        delete_1_review_page: "Verwijder 1 Beoordelingspagina",
        delete_1_widget: "Widget verwijderen",
        delete_agency: "Verwijder agentschap",
        delete_custom_field: "Aangepast veld verwijderen",
        delete_customer: "Klant verwijderen",
        delete_customers: "Klanten verwijderen",
        delete_external_link: "Externe Koppeling verwijderen",
        delete_field: "Verwijder veld",
        delete_link: "Koppeling verwijderen",
        delete_location: "Locatie verwijderen",
        delete_message: "Bericht verwijderen",
        delete_n_customers: "Verwijder {count} klanten",
        delete_n_review_pages: "Verwijder {count} Beoordelingspagina's",
        delete_n_reviews: "Verwijder {count} Beoordelingen",
        delete_n_widgets: "Widgets verwijderen {count}",
        delete_project: "Project verwijderen",
        delete_qr_code: "QR-code verwijderen",
        delete_reply: "Reactie verwijderen",
        delete_review: "Beoordeling verwijderen",
        delete_review_page: "Beoordelingspagina verwijderen",
        delete_review_pages: "Beoordelingspagina's verwijderen",
        delete_reviews: "Beoordelingen verwijderen",
        delete_signature: "Handtekening verwijderen",
        delete_source: "Bron verwijderen",
        delete_space: "Verwijder Werkruimte",
        delete_tag: "Tag verwijderen",
        delete_tag_rule: "Tagregel verwijderen",
        delete_template: "Sjabloon verwijderen",
        delete_user: "Gebruiker verwijderen",
        delete_webhook: "Webhook verwijderen",
        delete_widget: "Widget verwijderen",
        delete_widgets: "Widgets verwijderen",
        deleted: "Verwijderd",
        delivered: "Afgeleverd",
        description: "Beschrijving",
        deselect_all: "Alles deselecteren",
        disable: "Uitzetten",
        disable_automatic_review_collection: "Automatische Beoordeling uitschakelen",
        disable_field: "Veld uitschakelen",
        disable_when_links_are_visible: "Uitschakelen wanneer links zichtbaar zijn",
        disabled: "Uitgeschakeld",
        disconnect: "Loskoppelen",
        disconnect_integration: "Ontkoppel integratie",
        discord_community: "Discord gemeenschap",
        display_name: "Weergavenaam",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC -status voor",
        do_not_hide_from_public: "Verberg je niet voor het publiek",
        do_not_send: "Niet verzenden",
        docs: "Dokters",
        documentation: "Documentatie",
        domain: "Domein",
        domain_name: "Domeinnaam",
        dont_have_an_account: "Heb je nog geen account?",
        dont_send_thanks: "Stuur geen bedankjes",
        download: "Download",
        download_records: "Download Records",
        download_template: "Sjabloon downloaden",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Duplicaat",
        duplicate_project: "Dupliceer project",
        duplicate_review_page: "Dubbele Beoordelingspagina",
        duplicate_reviews: "Dubbele Beoordelingen",
        duplicate_widget: "Widget dupliceren",
        edit: "Bewerken",
        edit_1_customer: "Bewerk 1 klant",
        edit_1_review: "Bewerk 1 Beoordeling",
        edit_client: "Client bewerken",
        edit_custom_field: "Aangepast veld bewerken",
        edit_customer: "Klant bewerken",
        edit_customers: "Klanten bewerken",
        edit_field: "Bewerk veld",
        edit_link: "Koppeling bewerken",
        edit_location: "Locatie bewerken",
        edit_member: "Lid bewerken",
        edit_n_customers: "Bewerk {count} Klanten",
        edit_n_reviews: "Bewerk {count} Beoordelingen",
        edit_notes: "Notities bewerken",
        edit_qr_code: "QR-code bewerken",
        edit_reviews: "Beoordelingen bewerken",
        edit_signature: "Handtekening bewerken",
        edit_source: "Bron bewerken",
        edit_strategy: "Strategie bewerken",
        edit_tag: "Tag bewerken",
        edit_tag_rule: "Tagregel bewerken",
        edit_team_member: "Teamlid bewerken",
        edit_visibility: "Bewerk zichtbaarheid",
        edit_webhook: "Webhook bewerken",
        editable_ratings: "Bewerkbare beoordelingen",
        earned: "Verdiend",
        eligible: "In aanmerking komend",
        email: "E-mail",
        email_address: "E-mailadres",
        email_validation_invalid: "E-mailvalidatie mislukt",
        email_validation_passed: "E-mailvalidatie geslaagd",
        email_validation_unknown: "E-mailadres kon niet worden geverifieerd",
        emails: "E-mails",
        embed_code: "Insluitcode",
        enable: "Inschakelen",
        enable_automatic_review_collection: "Automatische Beoordeling inschakelen",
        enable_for_all_reviews: "Inschakelen voor alle beoordelingen",
        enable_for_positive_reviews: "Inschakelen voor positieve beoordelingen",
        enable_on_review_pages: "Inschakelen op beoordelingspagina's",
        enabled: "Ingeschakeld",
        end: "Einde",
        ends: "Einden",
        exclude: "Uitsluiten",
        exclude_email: "E-mail uitsluiten",
        exclude_sms: "SMS uitsluiten",
        excluded_channels: "Uitgesloten kanalen",
        expand: "Uitbreiden",
        expired: "Verlopen",
        export: "Exporteren",
        export_1_customer: "Exporteer 1 klant",
        export_1_review: "Exporteer 1 Beoordeling",
        export_all: "Alles exporteren",
        export_all_customers: "Exporteer alle klanten",
        export_all_reviews: "Exporteer alle Beoordelingen",
        export_customers: "Klanten exporteren",
        export_n_customers: "Exporteer {count} Klanten",
        export_n_reviews: "Exporteer {count} Beoordelingen",
        export_reviews: "Beoordelingen",
        external_link: "Externe Koppeling",
        external_links: "Externe Koppelingen",
        extra_locations: "Extra locaties",
        faces: "Gezichten",
        failed: "Mislukt",
        feedback: "Feedback",
        field: "Veld",
        fields: "Velden",
        filter: "Filter",
        first: "Eerst",
        first_charged: "Eerst in rekening gebracht",
        first_name: "Voornaam",
        first_name_last_initial: "Voornaam, eerste letter van de achternaam",
        flag_as_duplicate: "Markeren als duplicaat",
        font: "Lettertype",
        font_family: "Lettertypefamilie",
        font_size: "Lettergrootte",
        footer: "Voettekst",
        for: "Voor",
        forgot_password: "Wachtwoord vergeten",
        form: "Formulier",
        free: "Gratis",
        free_requests_included: "Gratis verzoeken inbegrepen",
        from: "van",
        full_name: "Volledige naam",
        generate: "Genereren",
        generate_meta: "Meta genereren",
        generate_qr_code: "QR-code genereren",
        generate_reply: "Genereer antwoord",
        generate_review: "Beoordeling genereren",
        generating: "Genereren",
        get_started: "Aan de slag",
        get_started_checklist: "Controlelijst voor de start",
        get_the_lifetime_deal: "Ontvang de Lifetime Deal",
        getting_started: "Aan de slag",
        google_fonts: "Google -lettertypen",
        grouped_by_request: "Gegroepeerd op aanvraag",
        has_links: "Heeft Koppelingen",
        has_notes: "Bevat notities",
        has_redirects: "Heeft omleidingen",
        have_an_account: "Heb je een account?",
        header: "Koptekst",
        hidden: "Verborgen",
        hidden_from_search_engines: "Verborgen voor zoekmachines",
        hidden_reviews: "Verborgen Beoordelingen",
        hide: "Verbergen",
        hide_all_reviews: "Verberg alle beoordelingen",
        hide_avatar: "Avatar verbergen",
        hide_date: "Verberg datum",
        hide_drop_shadow: "Verberg slagschaduw",
        hide_field_label: "Verberg veldlabel",
        hide_from_public: "Verbergen voor publiek",
        hide_name: "Naam verbergen",
        hide_pagination: "Verberg paginering",
        highlight_color: "Markeer de kleur",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Uren",
        icon: "Icon",
        icon_size: "Icoongrootte",
        icons: "Pictogrammen",
        id: "ID",
        image: "Afbeelding",
        import: "Importeren",
        import_address1: "Adresregel 1 van de klant.",
        import_address2: "Adresregel 2 van de klant.",
        import_city: "De stad of gemeente van de klant.",
        import_company: "De bedrijfsnaam van de klant.",
        import_created_at: "De datum van de beoordeling.",
        import_customers: "Klanten importeren",
        import_email: "Het e-mailadres van de klant.",
        import_first_name: "De voornaam van de klant.",
        import_from_boost_space: "Importeer vanuit Boost.space",
        import_from_hubspot: "Importeren vanuit HubSpot",
        import_from_make_com: "Importeer van Make.com",
        import_from_pabbly: "Import van Pabbly",
        import_from_stripe: "Importeren vanuit Stripe",
        import_from_zapier: "Importeren vanuit Zapier",
        import_last_name: "De achternaam van de klant.",
        import_list: "Door komma's gescheiden lijst met",
        import_notes: "Notities uitsluitend voor intern gebruik.",
        import_phone: "Het telefoonnummer van de klant.",
        import_postal_code: "De postcode van de klant.",
        import_recent_reviews: "Importeer recente Beoordelingen",
        import_review: "De recensietekst.",
        import_reviews: "Beoordelingen",
        import_score: "De beoordeling is van 1 - 5.",
        import_signed_up_at: "De startdatum van de klant.",
        import_slug: "De slug of UUID van een",
        import_state: "De staat of regio van de klant.",
        incentive: "Beloning",
        include: "Erbij betrekken",
        include_sample_reviews: "Voeg beoordelingen toe.",
        incoming_webhook_url: "Inkomende webhook- URL",
        inherit: "Erven",
        initializing: "Initialiseren",
        initials: "Initialen",
        install_in: "Installeren in",
        insert_variable: "Variabele invoegen",
        instructions: "Instructies",
        integration: "Integratie",
        integrations: "Integraties",
        interval: "Interval",
        introduction: "Invoering",
        invite: "Uitnodiging",
        invite_client: "Nodig een Client uit",
        invite_failed: "Uitnodiging mislukt",
        invite_member: "Nodig een lid uit",
        invite_sent_to: "Uitnodiging verzonden naar",
        invite_team_member: "Nodig een teamlid uit",
        invited: "Uitgenodigd",
        issuer_url: "URL van de uitgever",
        italic: "Cursief",
        joined: "Toegetreden",
        key: "Sleutel",
        keywords: "Trefwoorden",
        keywords_in_replies: "Trefwoorden in Antwoorden",
        keywords_in_reviews: "Trefwoorden in Beoordelingen",
        kiosk_page: "Kioskpagina",
        label: "Label",
        label_font_size: "Labellettergrootte",
        labels: "Etiketten",
        language: "Taal",
        languages: "Talen",
        large: "Groot",
        last_charged: "Laatst in rekening gebracht",
        last_name: "Achternaam",
        layout: "Indeling",
        leave: "Vertrekken",
        leave_project: "Project verlaten",
        leave_space: "Werkruimte verlaten",
        left: "Links",
        let_clients_sign_in_with_sso: "Laat klanten inloggen met SSO",
        less: "minder",
        lifecycle_stage: "Levenscyclusfase",
        lifetime_deal: "Levenslange deal",
        light: "Licht",
        limit: "Beperken",
        limits: "Limieten",
        link: "Koppeling",
        link_color: "Linkkleur",
        link_reveal_position: "Koppeling onthullen positie",
        link_revealer_button: "Koppeling Knop",
        link_revealer_label: "Koppeling Onthuller Label",
        link_revealer_rating: "Koppeling Revealer-beoordeling",
        links: "Koppelingen",
        links_per_review_page: "Koppelingen per Beoordelingspagina",
        list: "Lijst",
        list_unsubscribe_headers: "List-Unsubscribe",
        load_more: "Meer laden",
        loading: "Laden",
        location: "Locatie",
        location_address: "Locatie Adres",
        location_name: "Locatie Naam",
        location_picker: "Locatiekiezer",
        locations: "Locaties",
        locations_limit: "Locatielimiet",
        log_in: "Inloggen",
        log_out: "Uitloggen",
        logo: "Logo",
        logo_height: "Hoogte logo",
        long: "Lang",
        lowest_rating: "Laagste beoordeling",
        ltd: "LTD",
        make_default: "Standaard maken",
        manage: "Beheren",
        manage_limits: "Limieten beheren",
        manage_overrides: "Overrides beheren",
        manage_payout_account: "Beheer uitbetalingsaccount",
        manage_subscription: "Abonnement beheren",
        manual_entry: "Handmatige invoer",
        max: "Maximaal",
        max_size: "Maximale grootte",
        maximum_characters: "Maximaal Tekens",
        maximum_customers: "Maximale klanten",
        maximum_locations: "Maximale locaties",
        maximum_members: "Maximaal aantal leden",
        maximum_review_length: "Maximale Beoordeling",
        maximum_tags: "Maximum aantal tags",
        maximum_widgets: "Maximaal aantal widgets",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "MCP Server URL",
        medium: "Medium",
        member: "Lid",
        members: "Leden",
        menu: "Menu",
        message: "Bericht",
        message_link_expiration: "Vervaldatum Koppeling",
        messaged: "Berichten",
        messages: "Berichten",
        messages_clicked: "Berichten aangeklikt",
        messages_sent: "Verzonden berichten",
        messaging_service_sid: "Berichtenservice SID",
        min: "Min.",
        min_size: "Minimale grootte",
        minimal_delay: "Minimale vertraging",
        minimum_characters: "Minimaal Tekens",
        minutes: "Minuten",
        month: "maand",
        monthly: "Maandelijks",
        monthly_email_requests: "Maandelijkse e-mailverzoeken",
        monthly_limit: "Maandelijkse limiet",
        monthly_pricing_only: "Alleen maandelijkse prijzen",
        monthly_request_limit: "Maandelijkse aanvraaglimiet",
        monthly_requests: "Maandelijkse verzoeken",
        monthly_sms_requests: "Maandelijkse SMS verzoeken",
        months: "Maanden",
        months_free: "{count} Maanden gratis",
        more: "meer",
        more_clients: "meer klanten",
        more_customers: "meer klanten",
        more_options: "Meer opties",
        more_patients: "meer patiënten",
        more_reviews: "meer beoordelingen",
        more_reviews_needed: "Er zijn meer beoordelingen nodig om het samen te vatten",
        more_users: "meer gebruikers",
        more_visitors: "meer bezoekers",
        most_negative: "Meest negatief",
        most_positive: "Meest positief",
        move: "Beweging",
        moved: "Verplaatst",
        name: "Naam",
        native_reviews: "Inheemse Beoordelingen",
        negative_term: "Negatieve term",
        negative_trends: "Negatieve trends",
        new: "Nieuw",
        new_password: "Nieuw wachtwoord",
        no: "Nee",
        no_available_options: "Geen beschikbare opties",
        no_credit_card_required: "Geen creditcard vereist",
        no_data_available: "Geen gegevens beschikbaar",
        no_negative_trends: "Nog geen negatieve trends",
        no_positive_trends: "Nog geen positieve trends",
        no_reminders: "Stuur geen herinneringen.",
        no_retries: "Geen nieuwe pogingen",
        no_review: "Geen beoordeling",
        none: "Geen",
        not_connected: "Niet verbonden",
        not_reviewed: "Niet Beoordeeld",
        notes: "Notities",
        notifications: "Meldingen",
        now: "Nu",
        number_of_charges: "Aantal betalingen",
        number_of_reminders: "Aantal herinneringen",
        number_of_retries: "Aantal nieuwe pogingen",
        number_of_review_suggestions: "Aantal Beoordeling",
        of: "van",
        off: "Uit",
        on: "Op",
        on_channel: "op kanaal {channel}.",
        opened: "Geopend",
        options: "Opties",
        or_log_in_with_email: "of log in met uw e-mailadres",
        or_sign_up_with_email: "of gebruik uw e-mailadres",
        our_reviews: "Onze Beoordelingen",
        output: "Uitvoer",
        page_footer: "Voettekst van de pagina",
        paid: "Betaald",
        paragraph: "Paragraaf",
        password: "Wachtwoord",
        past_month: "Afgelopen maand",
        past_months: "Afgelopen {inc} maanden",
        past_week: "Afgelopen week",
        past_year: "Afgelopen jaar",
        past_years: "Afgelopen {inc} jaar",
        paused: "Gepauzeerd",
        payment_method: "Betaalmethode",
        payout_status_completed: "Voltooid",
        payout_status_pending: "In behandeling",
        pending: "In behandeling",
        pending_deployment: "In afwachting van implementatie",
        pending_validation: "In afwachting van validatie",
        per_day: "per dag",
        per_month: "per maand",
        permissions: "Toestemmingen",
        phone: "Telefoon",
        phone_number: "Telefoonnummer",
        pixels: "pixels",
        placeholder: "Plaatsaanduiding",
        placement: "Plaatsing",
        plan: "Plan",
        plan_bullet1: "Verwijder onze branding op e-mails, pagina's en widgets",
        plan_bullet2: "Gebruik uw domein voor klantgerichte pagina's en het verzenden van e-mails",
        plan_bullet3: "Maak het product eigen met white labeling voor agentschappen",
        please_rate_our_service: "Geef een beoordeling van onze service.",
        png: "PNG",
        policies: "Beleid",
        popular: "Populair",
        port: "Poort",
        position: "Positie",
        positive_only: "Alleen positieve Beoordelingen",
        positive_term: "Positieve term",
        positive_trends: "Positieve trends",
        powered_by: "Aangedreven door",
        preview: "Voorvertoning",
        preview_kiosk_page: "Voorbeeldpagina van de kiosk",
        preview_review_page: "Voorbeeldpagina voor Beoordelingspagina",
        price: "Prijs",
        pricing: "Prijzen",
        primary_color: "Primaire kleur",
        priority: "Prioriteit",
        privacy_policy: "Privacybeleid",
        proceed_to_dashboard: "Ga naar Dashboard",
        product: "Product",
        profile: "Profiel",
        project: "Project",
        project_name: "Projectnaam",
        setup_ask_delay: "Hoe lang moet je wachten voordat je een beoordeling aanvraagt?",
        setup_reminders: "Hoeveel herinneringen moet ik versturen?",
        project_paused: "Dit project is gepauzeerd.",
        project_suspended: "Dit project is stopgezet.",
        project_website: "Projectwebsite",
        projects: "Projecten",
        projects_limit: "Projectenlimiet",
        publish: "Publiceren",
        publish_changes: "Publiceer de wijzigingen op alle andere beoordelingspagina's",
        published: "Gepubliceerd",
        purchase: "Aankoop",
        qr_code: "QR-code",
        qr_code_name_placeholder: "Tafel 1, Receptie",
        qr_codes: "QR-codes",
        quantity: "Hoeveelheid",
        query: "Vraag",
        quick_import: "Snel importeren",
        rating: "Score",
        rating_order: "Scoresvolgorde",
        rating_out_of: "beoordeling uit",
        rating_save_all: "Score opslaan voor elke beoordeling",
        rating_save_customer: "Score opslaan vóór een klantbeoordeling",
        rating_save_never: "Sla nooit een beoordeling op voordat u een beoordeling geeft",
        rating_selection: "Score Selectie",
        rating_selector: "Scoresselector",
        ratings: "Scores",
        read: "Lezen",
        reapply_highlights_eligible: "Genereer met AI hoogtepunten voor alle positieve beoordelingen.",
        reconnect: "Opnieuw verbinden",
        redeem: "Inwisselen",
        redirect_uri: "Omleidings-URI",
        redirects: "Omleidingen",
        refer_and_earn: "Verwijs en verdien",
        referral_billing_status_active: "Geabonneerd",
        referral_billing_status_canceled: "Geannuleerd",
        referral_billing_status_trial: "Proef",
        referral_billing_status_trial_expired: "Proefperiode verlopen",
        referral_billing_status_trial_expiring: "Proefperiode loopt af",
        referral_program: "Voorwaarden van het verwijzingsprogramma",
        referral_program_terms: "Voorwaarden van het verwijzingsprogramma",
        referrals: "Verwijzingen",
        refresh: "Vernieuwen",
        regenerate: "Regenereren",
        reject_all: "Alles afwijzen",
        related_reviews: "Vergelijkbare Beoordelingen",
        related_similarity: "Gelijkenis",
        remaining: "Overig",
        reminder: "Herinnering",
        reminders: "Herinneringen",
        remove: "Verwijderen",
        remove_client: "Client verwijderen",
        remove_cname: "CNAME verwijderen",
        remove_domain: "Domein verwijderen",
        remove_from_project: "Verwijderen uit project",
        remove_member: "Lid verwijderen",
        remove_smtp_configuration: "SMTP configuratie verwijderen",
        remove_team_member: "Teamlid verwijderen",
        rename: "Hernoemen",
        rename_template: "Sjabloon hernoemen",
        renews: "Vernieuwt",
        replied: "Beantwoord",
        reply: "Antwoord",
        reply_to: "Antwoord aan",
        replying_on: "Reageren op",
        request: "Verzoek",
        request_date: "Datum aanvragen",
        request_review: "Vraag een Beoordeling aan",
        request_reviews: "Verzoek om Beoordelingen",
        requested: "Gevraagd",
        requested_review: "Verzoek Beoordeling",
        requests: "Verzoeken",
        requests_left_this_month: "verzoeken die deze maand zijn achtergelaten",
        requests_remaining: "Verzoeken die nog openstaan",
        require_field: "Vereist veld",
        require_sso: "SSO vereist",
        require_subscription: "Klant moet een actief abonnement hebben",
        required: "Vereist",
        reschedule_message: "Bericht opnieuw plannen",
        resend_invite: "Uitnodiging opnieuw verzenden",
        reset_password: "Wachtwoord opnieuw instellen",
        restore: "Herstellen",
        restore_to_defaults: "Herstellen naar standaardinstellingen",
        restore_widget: "Widget herstellen",
        resubscribe: "Opnieuw abonneren",
        resubscribe_customer: "Abonnement verlengen",
        resync: "Opnieuw synchroniseren",
        resync_account: "Account opnieuw synchroniseren",
        resync_now: "Nu opnieuw synchroniseren",
        retries: "Opnieuw proberen",
        reveal_above_form: "Onthul bovenstaande formulier",
        reveal_after_submission: "Onthullen na indiening",
        reveal_below_form: "Toon onderstaand formulier",
        review: "Beoordeling",
        review_length: "Beoordeling Lengte",
        review_link: "Beoordelingslink",
        review_missed: "Beoordeling gemist",
        review_not_requested: "Beoordeling niet aangevraagd",
        review_origin: "Deze beoordeling is afkomstig van template",
        review_page: "Beoordelingspagina",
        review_pages: "Beoordelingspagina's",
        review_requested: "Beoordeling aangevraagd",
        review_spotlight: "Uitgelichte beoordeling",
        review_suggestion: "Beoordelingssuggestie",
        review_suggestions: "Suggesties voor Beoordeling",
        review_text: "Tekst van de beoordeling",
        review_wall: "Beoordelingsmuur",
        reviewed: "Beoordeeld",
        reviews: "Beoordelingen",
        reviews_ask: "Vragen",
        reviews_query_failed: "Er is iets misgegaan. Probeer het opnieuw.",
        reviews_query_placeholder: "Zoek naar beoordelingen of stel een vraag...",
        reviews_with_highlights: "Beoordelingen met hoogtepunten",
        reviews_with_replies: "Beoordelingen met antwoorden",
        reviews_without_replies: "Beoordelingen zonder reacties",
        revoke: "Herroepen",
        revoke_client: "App intrekken",
        roadmap: "Routekaart",
        role: "Rol",
        sans_serif: "schreefloos",
        save: "Opslaan",
        save_preferences: "Voorkeuren Opslaan",
        save_template: "Sjabloon Opslaan",
        save_template_as_new: "Nieuwe sjabloon Opslaan",
        saved: "Opgeslagen",
        schedule: "Schema",
        schedule_review_request: "Beoordelingsverzoek",
        scheduled: "Gepland",
        score: "Score",
        search: "Zoekopdracht",
        second: "Seconde",
        secret_key: "Geheime sleutel",
        sections: "Secties",
        security_code: "Beveiligingscode",
        select: "Selecteer",
        select_account: "Selecteer een account",
        select_all: "Selecteer alles",
        select_an_option: "Selecteer een optie",
        select_bulk_action: "Selecteer bulkactie",
        select_csv_file: "Selecteer CSV bestand",
        select_date: "Selecteer datum",
        select_field: "Selecteer een veld",
        select_icon: "Selecteer een pictogram",
        select_location: "Selecteer een locatie",
        select_plan: "Kies een plan",
        select_review: "Selecteer een Beoordeling",
        select_source: "Selecteer een bron",
        select_tag: "Selecteer een tag",
        selected: "Gekozen",
        send: "Versturen",
        send_1_reminder: "Stuur 1 herinnering",
        send_2_reminders: "Stuur 2 herinneringen",
        send_3_reminders: "Stuur 3 herinneringen",
        send_anytime: "Op elk gewenst moment verzenden",
        send_between: "Verzenden tussen",
        send_message: "Bericht verzenden",
        send_retries: "Verzend {count}-pogingen",
        send_retry: "Verzend {count} Opnieuw proberen",
        send_test: "Stuur een test",
        send_thanks: "Stuur dank",
        sender_email_address: "E-mailadres van de afzender",
        sender_id: "Afzender ID",
        sender_name: "Naam van de afzender",
        sending_domain: "Domein verzenden",
        sentiment: "Sentiment",
        sent: "Verstuurd",
        sent_replies: "Verzonden antwoorden",
        serif: "Schreef",
        settings: "Instellingen",
        share: "Deel",
        share_link: "Link delen",
        short: "Kort",
        show: "Show",
        show_1_suggestion: "Toon één suggestie",
        show_100_results: "Toon 100 resultaten",
        show_2_suggestions: "Toon twee suggesties",
        show_25_results: "Toon 25 resultaten",
        show_3_suggestions: "Toon drie suggesties",
        show_4_suggestions: "Toon vier suggesties",
        show_5_suggestions: "Toon vijf suggesties",
        show_50_results: "Toon 50 resultaten",
        show_all_reviews: "Toon alle beoordelingen",
        show_arrows: "Pijlen weergeven",
        show_avatar: "Avatar weergeven",
        show_cookie_consent_banner: "Cookietoestemmingsbanner weergeven",
        show_date: "Datum weergeven",
        show_dots: "Punten weergeven",
        show_drop_shadow: "Slagschaduw weergeven",
        show_field: "Toon veld op de volgende beoordelingen",
        show_full: "Toon volledige sterren",
        show_photo: "Alleen foto weergeven",
        show_positive_reviews: "Toon alleen positieve beoordelingen",
        show_to_public: "Aan het publiek tonen",
        showcase: "Showcase",
        showcase_page: "Showcase-pagina",
        sign_up: "Aanmelden",
        sign_up_for_free: "Meld je gratis aan",
        sign_up_with_email: "Aanmelden met e-mail",
        sign_in_with_sso: "Aanmelden met SSO",
        sign_up_with_google: "Aanmelden met Google",
        signature: "Handtekening",
        signatures: "Handtekeningen",
        signed_up: "Ingeschreven",
        since: "Sinds",
        size: "Maat",
        skip: "Overslaan",
        slug: "Slug",
        small: "Klein",
        sms: "SMS",
        smtp_configuration: "SMTP configuratie",
        sort: "Soort",
        source: "Bron",
        source_code: "Broncode",
        sources: "Bronnen",
        space: "Werkruimte",
        space_name: "Werkruimte",
        spaces: "Werkruimtes",
        split: "Split",
        sso: "SSO",
        star_color: "Sterrenkleur",
        stars: "Sterren",
        start: "Begin",
        start_free_trial: "Start gratis proefperiode",
        start_getting_more_reviews: "Begin meer Beoordelingen te ontvangen",
        status: "Staat",
        store_code: "Winkelcode",
        strategy: "Strategie",
        sub_processors: "Subprocessors",
        subject: "Onderwerp",
        subscribe: "Abonneren",
        subscription: "Abonnement",
        success_page: "Succespagina",
        suggestion: "Suggestie",
        suggestions: "Suggesties",
        summary: "Samenvatting",
        support: "Support",
        suspend: "Opschorten",
        suspend_project: "Project opschorten",
        suspended: "Opgeschort",
        svg: "SVG",
        switch_to_smtp_setup: "Overschakelen naar SMTP instellingen",
        switch_to_standard_setup: "Overschakelen naar standaardinstellingen",
        symbol: "Symbool",
        sync: "Synchroniseren",
        sync_account: "Account synchroniseren",
        sync_now: "Nu synchroniseren",
        sync_scheduled_time: "Synchronisatie gepland {time}",
        sync_with_facebook: "Synchroniseren met Facebook",
        sync_with_google: "Synchroniseren met Google",
        synced_time: "Gesynchroniseerd {time}",
        system: "Systeem",
        system_fonts: "Systeemlettertypen",
        tag: "Tag",
        tag_1_customer: "Tag 1 Klant",
        tag_1_review: "Tag 1 Beoordeling",
        tag_customers: "Klanten taggen",
        tag_existing_reviews: "Bestaande Beoordelingen Tag",
        tag_n_customers: "Tag {count} Klanten",
        tag_n_reviews: "Tag {count} Beoordelingen",
        tag_reviews: "Beoordelingen taggen",
        tag_rule: "Tag-regel",
        tag_with_ai: "Taggen met AI",
        tags: "Tags",
        tags_for_customers: "Tags voor klanten",
        tags_for_reviews: "Tags voor beoordelingen",
        team: "Team",
        team_member: "Teamlid",
        team_members: "Teamleden",
        template: "Sjabloon",
        templates: "Sjablonen",
        terms_of_service: "Servicevoorwaarden",
        test_template: "Testsjabloon",
        tests: "Testen",
        text: "Tekst",
        text_alignment: "Tekstuitlijning",
        text_color: "Tekstkleur",
        thank_you_messages: "Bedankt berichten",
        thanks: "Bedankt",
        theme: "Thema",
        third: "Derde",
        time_zone: "Tijdzone",
        timeframe: "Tijdsbestek",
        title: "Titel",
        tone: "Toon",
        top: "Bovenkant",
        top_left: "Linksboven",
        top_right: "Rechtsboven",
        total_charges: "Totaal aan betalingen",
        total_reviews: "Totaal aantal Beoordelingen",
        trigger: "Trigger",
        trigger_charged: "Verzoek verzenden na een Betaling",
        trigger_created: "Verzoek verzenden na aanmelding",
        try_free: "Probeer gratis",
        try_it_free: "Probeer het gratis",
        type: "Type",
        types: "Typen",
        unarchive: "Archief opheffen",
        unarchive_customer: "Klant uit het archief halen",
        underline: "Onderstrepen",
        unflag_as_duplicate: "Markeren als duplicaat ongedaan maken",
        unknown: "Onbekend",
        unlimited: "onbeperkt",
        unnamed: "Naamloos",
        unpublish: "Niet publiceren",
        unpublished: "Niet gepubliceerd",
        unreplied: "Geen antwoord",
        unsent_messages: "Niet verzonden berichten",
        unsubscribe: "Uitschrijven",
        unsubscribe_customer: "Uitschrijven als klant",
        unsubscribe_customers: "Klanten die zich willen afmelden",
        unsubscribe_text: "Tekst uitschrijven",
        unsubscribed: "Uitgeschreven",
        unsuspend: "Deblokkeren",
        unsuspend_project: "Project hervatten",
        unverified: "Ongeverifieerd",
        update: "Update",
        update_password: "Wachtwoord bijwerken",
        update_plan: "Plan bijwerken",
        update_share_template: "Sjabloon bijwerken",
        updated: "Bijgewerkt",
        updates: "Updates",
        upgrade: "Upgrade",
        upgrade_for_more: "Upgrade voor meer",
        upgrade_to_use: "Voer een upgrade uit om deze functie te gebruiken",
        upload: "Uploaden",
        upload_csv: "CSV uploaden",
        upload_icon: "Een pictogram uploaden",
        url: "URL",
        use: "Gebruik",
        use_filters_for_aggregate: "Gebruik filters voor aggregaten",
        user: "Gebruiker",
        user_id: "Gebruikers ID",
        user_info: "Gebruikersinfo",
        username: "Gebruikersnaam",
        utc: "UTC",
        validate: "Valideren",
        validate_customer_email: "Valideer klant-e-mailadres",
        validation: "Geldigmaking",
        validations: "Validaties",
        value: "Waarde",
        verify: "Verifiëren",
        verify_email_address: "E-mailadres verifiëren",
        view: "Bekijken",
        view_all: "Alles bekijken",
        view_all_features: "Bekijk alle functies",
        view_available_fields: "Bekijk beschikbare velden",
        view_documentation: "Documentatie bekijken",
        view_email_templates: "E-mailsjablonen bekijken",
        view_review_pages: "Bekijk Beoordelingspagina’s",
        view_reviews: "Bekijk Beoordelingen",
        view_settings: "Weergave-instellingen",
        view_setup_guide: "Bekijk de installatiehandleiding",
        view_showcase: "Bekijk de showcase",
        view_strategy: "Bekijk strategie",
        visibility: "Zichtbaarheid",
        visible: "Zichtbaar",
        visible_reviews: "Zichtbare Beoordelingen",
        visible_to_search_engines: "Zichtbaar voor zoekmachines",
        wait_between_reminders: "Wacht tussen herinneringen",
        wait_period: "Wachttijd",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Website",
        weekly: "Wekelijks",
        weeks: "Weken",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "met AI",
        worst_to_best: "Van slechtste naar beste",
        write: "Schrijven",
        written_reviews: "Geschreven Beoordelingen",
        year: "jaar",
        yearly: "Jaarlijks",
        yes: "Ja",
        your_referral_link: "Uw doorverwijslink"
    },
    landing: {
        announcement: "Krijg reputatierapporten met onze MCP-server",
        counter: "Sluit je aan bij meer dan 5.000 lokale dienstverlenende bedrijven",
        counter_agencies: "Gebruikt door 500+ bureaus voor reviewbeheer",
        counter_ai: "Beheer je reputatie via Claude & ChatGPT",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Krijg antwoorden zonder in te loggen op een ander dashboard.",
            "Benut je reputatie in de chattools die je team al gebruikt.",
            "Opslaan wekelijks uren door te vragen in plaats van zelf te zoeken."
        ],
        ai_screen_1_subtitle: "Je reputatiemanagement moet aansluiten bij je eigen denkpatroon. Vraag Claude of ChatGPT wat je wilt weten, wie je vervolgens moet benaderen of hoe de week is verlopen, en krijg direct antwoord zonder van tool te hoeven wisselen.",
        ai_screen_1_title: "Vraag het aan Claude of ChatGPT",
        ai_screen_2_badge: "AI-antwoorden",
        ai_screen_2_bullets: [
            "Reageer sneller zonder generiek over te komen.",
            "Laat nooit beoordelingen onbeantwoord als je het druk hebt.",
            "Bescherm de stem van uw merk bij elk publiek antwoord."
        ],
        ai_screen_2_subtitle: "Elke onbeantwoorde review is een gemiste kans om vertrouwen te winnen. AI stelt antwoorden op die klinken alsof ze van jou zijn, zodat je de wachtrij binnen enkele minuten kunt wegwerken en beschikbaar kunt blijven voor klanten zonder dat je zelf hoeft te schrijven.",
        ai_screen_2_title: "Antwoord zonder onnodige ballast.",
        ai_screen_3_badge: "AI-suggesties",
        ai_screen_3_bullets: [
            "Zorg dat meer klanten de eindstreep halen.",
            "Verzamel specifieke en deelbare feedback.",
            "Zet tevreden bezoekers om in beoordelingen die het waard zijn om te delen."
        ],
        ai_screen_3_subtitle: "De meeste mensen zijn van plan een recensie te schrijven, maar doen het uiteindelijk nooit. Gebruik duidelijke bewoordingen in je eigen stijl, zodat de recensie beter overkomt en de inhoud sterker is dan je zou denken.",
        ai_screen_3_title: "Ontvang meer 5- beoordelingen",
        ai_screen_4_badge: "AI-tagging",
        ai_screen_4_bullets: [
            "Herken patronen voordat ze problemen worden.",
            "Ontdek de thema's die daadwerkelijk de kijkcijfers beïnvloeden.",
            "Bespaar uzelf de moeite om honderden beoordelingen handmatig te lezen."
        ],
        ai_screen_4_subtitle: "Je hoeft niet elke recensie opnieuw te lezen om te weten wat er speelt. AI organiseert feedback op basis van de thema's die voor jou relevant zijn, zodat je problemen sneller kunt oplossen en je kunt richten op wat klanten waarderen.",
        ai_screen_4_title: "Weet wat klanten zeggen.",
        ai_summary_1_desc: "Stel standaardantwoorden op voor Google en Facebook die bij je toon passen, of verstuur automatische antwoorden volgens een schema.",
        ai_summary_1_title: "AI-antwoorden",
        ai_summary_2_desc: "Geef klanten direct bruikbare beoordelingssuggesties wanneer ze feedback achterlaten op je pagina.",
        ai_summary_2_title: "AI-beoordelingssuggesties",
        ai_summary_3_desc: "Benadruk de beste zinnen uit positieve beoordelingen in widgets, showcases en deel afbeeldingen.",
        ai_summary_3_title: "AI-hoogtepunten",
        ai_summary_4_desc: "Gebruik tags op basis van de regels die je zelf definieert, zodat thema's zoals wachttijden of servicekwaliteit overzichtelijk blijven.",
        ai_summary_4_title: "AI automatische tagging",
        ai_summary_5_desc: "Ontvang beknopte samenvattingen van recente beoordelingen met aantallen, thema's en aandachtspunten die de moeite waard zijn om op te nemen.",
        ai_summary_5_title: "Samenvattingen van Beoordeling",
        ai_summary_6_desc: "Ontdek de toenemende lof en opkomende klachten zonder elke recensie handmatig te hoeven lezen.",
        ai_summary_6_title: "Positieve en negatieve trends",
        ai_summary_7_desc: "Zoek naar vergelijkbare beoordelingen naast de feedback, zodat patronen en herhalingen gemakkelijk te herkennen zijn.",
        ai_summary_7_title: "Gerelateerde beoordelingen",
        ai_summary_8_desc: "Stel vragen in begrijpelijke taal over je beoordelingen en ontvang antwoorden met bronvermeldingen die je kunt openen.",
        ai_summary_8_title: "Vraag het aan AI",
        ai_summary_9_desc: "Verbind Claude, ChatGPT en andere MCP clients om reputatiebeheer in chatgesprekken te realiseren.",
        ai_summary_9_title: "MCP voor assistenten",
        ai_summary_10_desc: "Ontvang live reputatierapporten met informatie over volume, beoordelingen, locaties, reacties en bereik.",
        ai_summary_10_title: "Reputatierapporten",
        ai_summary_11_desc: "Richtingstoon, zoekwoorden en aangepaste instructies zorgen ervoor dat elke AI-uitvoer klinkt als uw merk.",
        ai_summary_11_title: "Merkbewuste AI",
        ai_summary_12_desc: "Score hoe sterk geschreven reviews positief of negatief aanvoelen, verder dan sterren, zodat je kunt sorteren wat aandacht nodig heeft.",
        ai_summary_12_title: "Sentiment",
        industries: {
            accountants: "Accountants",
            auto_repair: "Automonteurs",
            chiropractors: "Chiropractors",
            cleaning: "Schoonmakers",
            contractors: "Aannemers",
            dentists: "Tandartsen",
            doctors: "Artsen",
            electricians: "Elektriciens",
            financial_advisors: "Financieel adviseurs",
            hvac: "HVAC-technici",
            insurance_brokers: "Verzekeringsadviseurs",
            landscapers: "Hoveniers",
            law_firms: "Advocaten",
            locksmiths: "Slotenmakers",
            mortgage_brokers: "Hypotheekadviseurs",
            optometrists: "Optometristen",
            personal_trainers: "Personal trainers",
            pest_control: "Ongediertebestrijders",
            physical_therapists: "Fysiotherapeuten",
            plumbers: "Loodgieters",
            real_estate: "Makelaars",
            restaurants: "Restauranteigenaren",
            salons: "Kappers",
            self_storage: "Opslagexploitanten",
            spas: "Beautyspecialisten",
            tour_guides: "Reisgidsen",
            veterinarians: "Dierenartsen"
        },
        industries_title: "Reviewbeheer voor lokale dienstverleners",
        stat_1_article: "Consumentenonderzoeksrapport",
        stat_1_desc: "Mensen willen meer dan 100 beoordelingen voordat ze een bedrijf online vertrouwen.",
        stat_1_source: "Salsify",
        stat_1_title: "Beoordelingen winnen vertrouwen.",
        stat_2_article: "Lokale Beoordeling",
        stat_2_desc: "Klanten die lokale bedrijven vergelijken, geven de voorkeur aan bedrijven die op elke recensie reageren.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Kies wie antwoordt",
        stat_3_article: "Beoordelingen, reputatie en omzet",
        stat_3_desc: "Een kleine ratingverhoging kan een flinke impact hebben op je inkomen.",
        stat_3_source: "Harvard Business School",
        stat_3_title: "Omzet per ster",
        stat_4_article: "Consumentenvertrouwen in AI-zoekresultaten",
        stat_4_desc: "Als mensen aan AI vragen wie ze moeten kiezen, helpen jouw beoordelingen bij het formuleren van het antwoord.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Vertrouw op AI-zoekopdrachten",
        subtitle: "Vraag reviews op de automatische piloot. Krijg meer 5-sterrenbeoordelingen. Behaal een hogere positie dan uw concurrenten.",
        agencies_screen_1_badge: "Portaal",
        agencies_screen_1_bullets: [
            "Verkoop een merkportal bij elke retainer.",
            "Houd klanten binnen uw eigen ecosysteem, niet via een login van een derde partij.",
            "Lijk op een softwarebedrijf, zonder er daadwerkelijk een te bouwen."
        ],
        agencies_screen_1_subtitle: "Geef elke klant een portaal dat eruitziet als een product dat jij hebt gebouwd: jouw logo, kleuren, domein. Verpak reviewbeheer daarna als een terugkerende dienst waarop ze elke maand inloggen. Je beveelt geen tool aan. Je levert er een.",
        agencies_screen_1_title: "Een portaal waarvan ze denken dat jij het hebt gebouwd",
        agencies_screen_2_badge: "Controle",
        agencies_screen_2_bullets: [
            "Stem de functies af op de starter-, groei- en premium-pakketten.",
            "Nodig de juiste mensen uit en bepaal wat elke klant te zien krijgt.",
            "Overschrijf verzoeken, locaties en limieten per project"
        ],
        agencies_screen_2_subtitle: "Niet elke klant hoeft alles te krijgen. Nodig teams uit voor specifieke projecten, stel rollen in en overschrijf features en limieten per account zodat je pakketten aansluiten op je facturatie. Upsell toegang naarmate klanten groeien, zonder maatwerk voor elk pakket.",
        agencies_screen_2_title: "Beheer toegang per klant",
        agencies_screen_3_badge: "AI",
        agencies_screen_3_bullets: [
            "Bied AI-antwoorden aan die klanten wekelijks uren opslaan .",
            "Neem contact op met Claude of andere assistenten via het MCP van elk project.",
            "AI als premium add-on aanbieden aan klanten"
        ],
        agencies_screen_3_subtitle: "Beheer niet alleen reviews. Geef klanten AI die antwoorden opstelt, feedback tagt en via Claude of andere assistants werkt door de project-MCP-server. Dat is een moderne capability die bureaus kunnen verpakken, upsellen en vernieuwen — zonder contentteam per account.",
        agencies_screen_3_title: "AI waar klanten voor betalen",
        agencies_screen_4_badge: "Schaal",
        agencies_screen_4_bullets: [
            "Beheer beoordelingen voor meerdere bedrijven vanuit één account.",
            "Voeg locaties toe zodra u ze wint, met volumekorting.",
            "Zet elke nieuwe klant om in terugkerende inkomsten."
        ],
        agencies_screen_4_subtitle: "Eén bureauseat. Tientallen bedrijven. Draai reviewverzameling, antwoorden en reporting over elke klantlocatie vanuit één hub, en groei je marge naarmate je accounts toevoegt. Zo maken bureaus van reputatie een schaalbare inkomstenstroom, geen eenmalig project.",
        agencies_screen_4_title: "Schaal over elke klant",
        agencies_summary_10_desc: "Schakel Claude of andere assistenten in om projecten, klanten en het team te beheren.",
        agencies_summary_10_title: "Agentschap MCP",
        agencies_summary_11_desc: "Elke klant krijgt de volledige toolkit voor reviews: verzameling, AI, widgets en meer.",
        agencies_summary_11_title: "Alles in het bedrijfsleven",
        agencies_summary_12_desc: "Krijg hulp van een team dat de workflows van bureaus en de implementatie bij klanten begrijpt.",
        agencies_summary_12_title: "Toegewijde ondersteuning",
        agencies_summary_1_desc: "Clients beheren hun reputatie via een portaal dat eruitziet als een product dat u zelf hebt ontwikkeld.",
        agencies_summary_1_title: "Klantenportaal met eigen huisstijl",
        agencies_summary_2_desc: "Host het portaal op uw eigen domein, zodat elke login onder uw merknaam plaatsvindt.",
        agencies_summary_2_title: "Domain van een maatwerkagentschap",
        agencies_summary_3_desc: "Laat klanten met één klik inloggen via uw identiteitsaanbieder.",
        agencies_summary_3_title: "Enkelvoudig aanmelden",
        agencies_summary_4_desc: "Nodig klanten uit voor specifieke projecten en bepaal wat ze te zien krijgen.",
        agencies_summary_4_title: "Client en rollen",
        agencies_summary_5_desc: "Beperk de aanvragen, locaties en functies per project, zodat deze overeenkomen met uw pakketten.",
        agencies_summary_5_title: "Overrides per project",
        agencies_summary_6_desc: "Geef je interne team volledige toegang tot elk klantproject.",
        agencies_summary_6_title: "Teamzetels van het agentschap",
        agencies_summary_7_desc: "Begin met 5 locaties en voeg er later meer toe met volumekortingen naarmate uw bedrijf groeit.",
        agencies_summary_7_title: "Schaal voor meerdere locaties",
        agencies_summary_8_desc: "Systeemnotificaties worden verzonden vanuit uw bureaudomein en per project wanneer klanten hun eigen domein niet hebben toegevoegd.",
        agencies_summary_8_title: "White label verzending",
        agencies_summary_9_desc: "Automatiseer projecten, klanten en teams met de Agency API.",
        agencies_summary_9_title: "Agency API",
        demo_footer: "Kies een tijdstip dat u uitkomt. We laten u alles zien en beantwoorden uw vragen.",
        desc_contact: "Heeft u een vraag of hulp nodig bij iets? Stuur hieronder een bericht en wij nemen het verder over.",
        mcp_aria: "Demonstratie van een AI-assistent gekoppeld aan More Good Reviews via MCP.",
        mcp_prompts_aria: "Voorbeelden van prompts",
        review_flow_aria: "Kaartcarrousel met e-mailverzoeken voor beoordelingen, de beoordelingspagina, Google beoordelingen en privéfeedback.",
        review_flow_autopilot: "Werkt op de automatische piloot.",
        review_flow_card_email_desc: "Als je klaar bent met een klant, sturen we automatisch een e-mail met je bedrijfslogo en een link naar je beoordelingspagina.",
        review_flow_card_email_title: "Verzend het verzoek",
        review_flow_card_feedback_desc: "Lagere beoordelingen leiden eerst tot privéfeedback, zodat u het kunt corrigeren. Klanten kunnen er nog steeds voor kiezen om een openbare beoordeling te plaatsen.",
        review_flow_card_feedback_title: "Ontvang lastige feedback",
        review_flow_card_google_desc: "Tevreden klanten kunnen eenvoudig een openbare Google recensie achterlaten, waardoor positieve feedback zichtbaar wordt waar nieuwe klanten zoeken.",
        review_flow_card_google_title: "Betuig uw waardering aan Google.",
        review_flow_card_review_desc: "Ze komen op je beoordelingspagina terecht, geven een beoordeling en de volgende stap hangt af van hoe het is gegaan.",
        review_flow_card_review_title: "De Klant kiest een beoordeling.",
        review_flow_next: "Volgende stap",
        review_flow_prev: "Vorige stap",
        review_flow_step_email: "Verzoek een Beoordeling aan",
        review_flow_step_feedback: "of vraag om feedback",
        review_flow_step_google: "Route naar elke Beoordeling",
        review_flow_step_review: "Vraag om een Score",
        review_flow_steps_aria: "Stappen voor het Beoordeling van een verzoek",
        summary_10_desc: "Organiseer klanten en beoordelingen zodat u snel kunt filteren en actie kunt ondernemen.",
        summary_10_title: "Klant en beoordelingstags",
        summary_11_desc: "Zapier koppelt More Good Reviews aan de tools die je al gebruikt.",
        summary_11_title: "Verbinden met elke app",
        summary_12_desc: "Beheer je reputatie bij Claude, ChatGPT en andere MCP klanten.",
        summary_12_title: "MCP voor AI-assistenten",
        summary_1_desc: "Geplande e-mail- en SMS berichten met herinneringen, volledig geautomatiseerd.",
        summary_1_title: "Automatische beoordelingsverzoeken",
        summary_2_desc: "E-mails en SMS die aansluiten bij uw merk, stijl en aanbod.",
        summary_2_title: "Sjablonen met merklogo",
        summary_3_desc: "Verzamel privéfeedback of verwijs mensen door naar Google, Facebook en meer.",
        summary_3_title: "Beoordeling 's",
        summary_4_desc: "Printbare codes en volledige schermweergave in de winkel.",
        summary_4_title: "QR-codes en kiosk",
        summary_5_desc: "Integreer beoordelingen en beoordelingen overal op uw website.",
        summary_5_title: "Website-widgets",
        summary_6_desc: "Een openbare pagina die u kunt personaliseren met uw merk voor uw beste beoordelingen.",
        summary_6_title: "Showcase",
        summary_7_desc: "Importeren beoordelingen en reageer vanuit één centrale plek.",
        summary_7_title: "Google en Facebook-synchronisatie",
        summary_8_desc: "Suggesties op de pagina die klanten helpen een recensie achter te laten.",
        summary_8_title: "Hulp bij het schrijven van AI-reviews",
        summary_9_desc: "Stel conceptantwoorden, samenvattingen en trends op en vraag AI naar aanleiding van je beoordelingen.",
        summary_9_title: "AI-reacties en inzichten",
        subtitle_agencies_feature_summary: "White-labelportaal, klanttoegang, schaal en automatisering onder jouw merk.",
        subtitle_ai_feature_summary: "Reacties, tags, inzichten en assistenten geïntegreerd in uw reputatieworkflow.",
        subtitle_feature_summary: "Verzamelen, tonen, AI en integraties — klaar wanneer jij dat bent.",
        subtitle_mcp: "Koppel Claude, ChatGPT en andere MCP-clients, en vraag in natuurlijke taal naar reviews, locaties en outreach.",
        subtitle_review_flow: "Vraag automatisch om reviews. Klanten kunnen altijd een openbare review achterlaten. Privéfeedback is optioneel.",
        title: "AI-reputatiemanagement om",
        title_agencies: "Maak van reviews",
        title_agencies_feature_summary: "Alles wat bureaus nodig hebben",
        title_agencies_phrases: {
            branded_product: "een branded product dat van jou is",
            recurring_retainers: "maandelijks terugkerende retainers",
            revenue_stream: "een nieuwe inkomstenstroom"
        },
        title_ai: "Vraag het aan je AI",
        title_ai_feature_summary: "Alles wat AI voor je kan doen",
        title_ai_phrases: {
            weekly_report: "voor een wekelijks reputatierapport",
            send_from_chat: "om beoordelingsverzoeken te versturen",
            next_steps: "voor de volgende stappen die genomen moeten worden"
        },
        title_contact: "Hoe kunnen wij helpen?",
        title_faq: "Veelgestelde vragen",
        title_feature_summary: "Alles in één pakket",
        title_footer: "Stop met het najagen van recensies. Begin ze te krijgen.",
        title_footer_ai: "over uw reputatie",
        title_ltd: "Betaal eenmalig en gebruik het voor altijd met onze tijdelijke, levenslange deal.",
        title_mcp: "Vraag AI over je reputatie",
        title_review_flow: "Maak van geweldige ervaringen reviews",
        title_phrases: {
            autopilot: "automatisch reviews aan te vragen",
            google_reviews: "meer Google-reviews te krijgen",
            suggested_by_chatgpt: "voorgesteld te worden door ChatGPT"
        },
        title_pricing: "Alle functies. Eenvoudige prijsstelling.",
        title_reviews: "Ontdek waarom wij als #1 worden beoordeeld in reviewbeheer"
    },
    plans: {
        agency: {
            agency_api: "Agency API",
            branded_portal: "Klantenportaal met eigen huisstijl",
            client_invites: "Client , rollen en overschrijvingen",
            custom_domain: "Domain van een maatwerkagentschap",
            everything_in_business: "Alles in het bedrijfsplan",
            locations_included: "5 locaties inbegrepen",
            review_requests: "5.000 beoordelingsverzoeken per locatie per maand",
            sso: "Single sign-on (SSO)",
            support: "Toegewijde klantenservice",
            volume_pricing: "Volumekorting vanaf $49\/maand"
        },
        business: {
            ai: "AI-antwoorden, inzichten & Vraag AI",
            api_mcp: "API en MCP Server",
            custom_domains: "Aangepaste domeinen voor e-mail en beoordelingspagina's",
            google_facebook: "Google Bedrijfsprofiel & Facebook",
            locations_included: "1 locatie inbegrepen",
            review_requests: "{count} beoordelingsverzoeken \/ locatie \/ maand",
            support: "Toegewijde klantenservice",
            unlimited_customers: "Onbeperkt aantal klanten",
            volume_pricing: "Volumekorting vanaf $99\/maand"
        },
        descriptions: {
            agency: "Voor bureaus die de reputatie van hun klanten onder hun eigen merk beheren. Vijf locaties inbegrepen met groothandelstarieven naarmate u groeit, plus een eigen portaal en toegang voor uw klanten.",
            business: "Voor bedrijven die hun eigen reputatie beheren. Betaal per locatie met volumekortingen en krijg AI, integraties en een onbeperkt aantal klanten erbij."
        },
        selectors: {
            agency_included: "{count} Locaties inbegrepen",
            agency_tier: "+{from}–{to} locaties · {price}\/{month} elk",
            agency_tier_plus: "+{from}+ locaties · {price}\/{month} elk",
            business_tier: "{from}–{to} locaties · {price}\/{month} elk",
            business_tier_plus: "{from}+ locaties · {price}\/{month} elk"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Voeg een klant toe en vraag om een beoordeling.",
            customers_to_ask: "Zoek klanten die je om beoordelingen kunt vragen.",
            location_leaderboard: "Vergelijk de prestaties van de locaties",
            outreach_health: "Controleer de afleveringskwaliteit van verzoeken",
            review_digest: "Samenvatting van het wekelijkse overzicht",
            send_review_requests: "Verzend beoordelingsverzoeken in bulk"
        },
        texts: {
            add_customer_and_ask: "Voeg een nieuwe klant toe met behulp van de contactgegevens die ik je geef en plan vervolgens een verzoek voor een review in via e-mail met 2 herinneringen.",
            customers_to_ask: "Geef een lijst weer van maximaal 50 klanten die nog nooit om een recensie zijn gevraagd, gesorteerd op aanmelddatum met de meest recente eerst. Sla klanten over die zich hebben afgemeld. Vermeld naam, e-mailadres en aanmelddatum.",
            location_leaderboard: "Stel een ranglijst samen van 90 dagen per locatie met het aantal beoordelingen, de gemiddelde score, het percentage 5-sterrenbeoordelingen en de trend ten opzichte van de voorgaande 90 dagen. Sorteer op score en markeer elke daling van meer dan 0,2 sterren.",
            outreach_health: "Rapporteer voor e-mailberichten die in de afgelopen 14 dagen zijn verzonden het totaal aantal verzonden berichten, het bezorgingspercentage, het openingspercentage, het klikpercentage en het foutpercentage. Markeer eventuele afwijkingen.",
            review_digest: "Vat alle beoordelingen van de afgelopen 7 dagen samen. Vermeld het aantal recensies, de gemiddelde beoordeling, een uitsplitsing per bron en locatie, de 3 belangrijkste thema's en de 3 belangrijkste klachten.",
            send_review_requests: "Voor klanten die zich de afgelopen 30 dagen hebben aangemeld en nog geen beoordelingsverzoek hebben ontvangen, kunt u een verzoek per e-mail indienen met twee herinneringen. Toon eerst de lijst en wacht op mijn bevestiging."
        }
    },
    messages: {
        activated: "Succesvol geactiveerd.",
        archived: "Succesvol gearchiveerd.",
        canceled: "Succesvol geannuleerd.",
        cannot_copy: "Kan niet naar klembord kopiëren",
        cname_active: "De CNAME status is actief.",
        cname_not_active: "De CNAME status is nog niet actief.",
        connected: "Succesvol verbonden.",
        cookie_banner_text: "We gebruiken cookies om uw ervaring te verbeteren. U kunt uw voorkeuren aanpassen of alle cookies accepteren.",
        cookie_category_analytics_desc: "Deze cookies worden gebruikt om websiteverkeer en productgebruik te meten. Ze helpen ons te begrijpen hoe bezoekers onze site gebruiken.",
        cookie_category_essential_desc: "Altijd actief. Deze cookies zijn noodzakelijk voor de werking van de website en kunnen niet worden uitgeschakeld.",
        cookie_category_functional_desc: "Schakel geavanceerde functies zoals live chat in. Deze cookies volgen u niet voor reclamedoeleinden.",
        cookie_category_marketing_desc: "Gebruikt voor advertenties en campagnemeting. Dit kunnen tools zijn zoals advertentiepixels en attributietools.",
        copied: "Succesvol gekopieerd.",
        copied_to_all_ratings: "Gekopieerd naar alle beoordelingen. Opslaan om toe te passen.",
        created: "Succesvol aangemaakt.",
        deactivated: "Succesvol gedeactiveerd.",
        deleted: "Succesvol verwijderd.",
        disconnected: "Verbinding verbroken.",
        duplicated: "Succesvol gedupliceerd.",
        error: "Er is iets misgegaan. Probeer het opnieuw.",
        google_connect_failed: "We konden geen verbinding maken met Google. Je kunt het later nog eens proberen of dit nu overslaan.",
        inquiry_sent: "Bedankt voor uw bericht. We nemen binnenkort contact met u op.",
        oauth_consent_intro: "{client} vraagt toestemming om toegang te krijgen tot uw account.",
        oauth_request_missing: "Het OAuth-autorisatieverzoek ontbreekt of is verlopen.",
        operation_connection_sync_failed: "{integration_name} synchronisatie mislukt.",
        operation_connection_sync_progress: "V0 synchroniseren…",
        operation_connection_sync_success: "{integration_name} synchronisatie voltooid.",
        operation_customer_import_failed: "Klant is mislukt.",
        operation_customer_import_progress: "Klanten importeren…",
        operation_customer_import_success: "Klant voltooid.",
        operation_review_import_failed: "Beoordeling mislukt.",
        operation_review_import_progress: "beoordelingen importeren …",
        operation_review_import_success: "Beoordeling voltooid.",
        operation_review_scrape_failed: "Het importeren van recente beoordelingen is mislukt.",
        operation_review_scrape_progress: "Recente beoordelingen importeren …",
        operation_review_scrape_success: "Recente beoordelingsimport voltooid.",
        processed: "Succesvol verwerkt.",
        published: "Succesvol gepubliceerd.",
        purchased: "Succesvol gekocht.",
        queued: "Succesvol gepland.",
        refreshed: "Succesvol vernieuwd.",
        removed: "Succesvol verwijderd.",
        resubscribed: "Opnieuw geabonneerd.",
        revoked: "Succesvol ingetrokken.",
        saved: "Succesvol opgeslagen.",
        scheduled: "Succesvol gepland.",
        sent: "Succesvol verzonden.",
        started: "Succesvol gestart.",
        stopped: "Succesvol gestopt.",
        sso_failed: "Autorisatie via SSO mislukt.",
        sso_invalid_callback: "Ongeldige SSO-callback.",
        sso_not_configured: "SSO is niet geconfigureerd.",
        sso_openid_config_failed: "OpenID-configuratie kan niet worden geladen.",
        sso_token_exchange_failed: "De SSO-tokenuitwisseling is niet voltooid.",
        subscribed: "Succesvol geabonneerd.",
        suspended: "Succesvol opgeschort.",
        synced: "Succesvol gesynchroniseerd.",
        unarchived: "Succesvol uit het archief gehaald.",
        unpublished: "Succesvol niet gepubliceerd.",
        unscheduled: "Succesvol geannuleerd.",
        unsubscribed: "Uitgeschreven.",
        unsuspended: "Succesvol ongedaan gemaakt.",
        updated: "Succesvol bijgewerkt.",
        upgraded: "Succesvol geüpgraded.",
        validated: "Succesvol gevalideerd.",
        verified: "Succesvol geverifieerd."
    },
    notices: {
        agency: "Runt u een bureau? U kunt ons product whitelabelen, zodat uw klanten alleen uw merk zien wanneer ze de service gebruiken.",
        connected_apps: "Apps waarmee je via MCP verbinding maakt, verschijnen hier.",
        connector: "Importeer uw klanten uit duizenden applicaties met {brand}.",
        customer_messages: "Vraag een beoordeling aan om berichten te plannen.",
        customer_reviews: "Vraag een beoordeling aan deze klant.",
        customers: "Importeer uw klanten zodat ze beoordelingen kunnen aanvragen.",
        external_links: "Voeg externe links toe aan uw klantenportaal om uw diensten te verkopen. Deze links worden aan uw klanten getoond in de zijbalk.",
        links: "Voeg knoppen toe aan uw pagina om beoordelingen achter te laten op websites van derden.",
        locations: "Maak een locatie aan, zodat u beoordelingen aan meerdere locaties kunt toewijzen.",
        ltd: "Ontgrendel levenslange toegang met uw toegangscode. Elke code bevat een beperkt aantal maandelijkse verzoeken, plus alle functies. Codes zijn stapelbaar. 3 of meer codes ontgrendelen het agency-abonnement. Voer hieronder uw toegangscodes in.",
        mcp_example_prompts: "Zodra de MCP server is verbonden, plak je deze gegevens in je assistent als uitgangspunt.",
        messages: "Alle verzoeken en herinneringen die uw klanten ontvangen wanneer zij een beoordeling opvragen, worden hier weergegeven.",
        no_commissions: "Je hebt nog geen commissies verdiend.",
        no_payouts: "Uitbetalingen worden handmatig verzonden zodra uw goedgekeurde saldo minimaal $50,00 bedraagt en uw bankrekening is gekoppeld.",
        no_projects: "Er is nog geen project aan je toegewezen. Neem contact op met je beheerder voor toegang.",
        no_referrals: "Je hebt nog niemand doorverwezen. Deel je doorverwijslink om te beginnen.",
        qr_codes: "Maak QR-codes met aangepaste kleuren, locaties en tags. Download als SVG of PNG.",
        referrals_share_subject: "Mijn AI-reputatiemanager",
        referrals_share_text: "Mijn geheime wapen voor het verkrijgen van beoordelingen: More Good Reviews. AI-reputatiemanagement dat echt werkt. Meld je aan via mijn link:",
        review_pages: "Uw project kan meerdere beoordelingspagina's hebben waar uw klanten beoordelingen kunnen achterlaten. Dit is handig voor bedrijven met meer dan één locatie.",
        reviews: "We wachten op beoordelingen van uw klanten.",
        showcase: "We zijn nog maar net begonnen.",
        signatures: "Maak een e-mailhandtekening aan die u kunt kopiëren en plakken in uw e-mailprogramma.",
        sources: "Maak een bron aan, zodat u uw beoordelingen kunt categoriseren.",
        tag_rules: "Maak een regel om uw beoordelingen automatisch te categoriseren met behulp van AI.",
        tags: "Maak een tag aan om uw beoordelingen en klanten te categoriseren.",
        unauthorized: "U hebt geen toestemming om deze pagina te bezoeken.",
        unsubscribed: "U bent nu afgemeld voor beoordelingsverzoeken.",
        webhooks: "Voeg webhooks toe om meldingen over platformgebeurtenissen te ontvangen.",
        widgets: "Maak widgets om beoordelingen op uw website in te sluiten.",
        your_referral_link_text: "Deel je link en verdien {rate}% terugkerende commissie op elke betaling van klanten die je doorverwijst. Uitbetalingen worden handmatig verzonden zodra je goedgekeurde saldo minimaal $50,00 bedraagt."
    },
    notification_types: {
        descriptions: {
            imports: "Verzonden zodra de import is voltooid",
            new_reviews: "Verzonden zodra de beoordelingen zijn ontvangen.",
            sent_replies: "Verzonden wanneer beoordelingen automatisch worden beantwoord.",
            weekly_reports: "Een wekelijkse samenvatting van de activiteiten."
        },
        names: {
            imports: "Importen",
            new_reviews: "Nieuwe Beoordelingen",
            sent_replies: "Verzonden antwoorden",
            weekly_reports: "Wekelijkse rapporten"
        }
    },
    roles: {
        manager: "Manager",
        operator: "Operator",
        owner: "Eigenaar",
        super_admin: "Beheerder",
        viewer: "kijker"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Uitnodiging accepteren",
        accepting_invite: "Uitnodiging accepteren",
        access_denied: "Toegang geweigerd",
        account: "Account",
        actions: "Acties",
        add_custom_field: "Aangepast veld toevoegen",
        add_ons: "Add-ons",
        address: "Adres",
        agencies: "Bureaus",
        agency: "Bureau",
        ai: "AI",
        ai_assistant: "AI-assistent",
        ai_highlights: "Hoogtepunten van AI",
        ai_replies: "AI-antwoorden",
        ai_review_suggestions: "Suggesties voor AI- Beoordeling",
        analytics: "Analyse",
        api: "API",
        api_key: "API sleutel",
        appearance: "Verschijning",
        application_connectors: "Toepassingsconnectoren",
        attributes: "Attributen",
        authorize: "Autoriseren",
        auto_tagging: "Automatisch taggen",
        automatic_review_collection: "Automatische Beoordeling",
        billing: "Facturering",
        branding: "Merknaam",
        change_password: "Wachtwoord wijzigen",
        clients: "Klanten",
        cname: "CNAME",
        conditions: "Voorwaarden",
        confirmation_message: "Bevestigingsbericht",
        connected_apps: "Verbonden apps",
        contact_us: "Neem contact met ons op",
        cookie_policy: "Cookiebeleid",
        cookie_preferences: "Cookievoorkeuren",
        copy: "Kopiëren",
        create_your_account: "Maak uw account aan",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Aangepast veld",
        custom_fields: "Aangepaste velden",
        custom_icons: "Aangepaste pictogrammen",
        customer: "Klant",
        customer_facing_pages: "Klantgerichte pagina's",
        customers: "Klanten",
        dashboard: "Bedieningsoverzicht",
        details: "Details",
        dmarc: "DMARC",
        domain: "Domein",
        dpa: "Gegevensverwerkingsovereenkomst",
        dsar: "Verzoek om inzage in persoonsgegevens",
        email_address: "E-mailadres",
        email_messages: "E-mailberichten",
        email_settings: "E-mailinstellingen",
        email_usage: "E-mailgebruik",
        emails: "E-mails",
        embed_code: "Insluitcode",
        examples: "Voorbeelden",
        export: "Exporteren",
        external_link: "Externe Koppeling",
        external_link_num: "Externe Koppeling #{num}",
        external_links: "Externe Koppelingen",
        field: "Veld",
        fields: "Velden",
        filters: "Filteren",
        form_fields: "Formuliervelden",
        got_access_code: "Heeft u een toegangscode?",
        hipaa: "HIPAA-verklaring",
        how_it_works: "Hoe het werkt",
        incentive: "Beloning",
        instructions: "Instructies",
        integration: "Integratie",
        integrations: "Integraties",
        javascript: "JavaScript",
        latest_reviews: "Laatste Beoordelingen",
        lifetime_deal: "Levenslange deal",
        limits: "Limieten",
        link: "Koppeling",
        links: "Koppelingen",
        location: "Locatie",
        location_picker: "Locatiekiezer",
        locations: "Locaties",
        log_in: "Inloggen",
        log_out: "Uitloggen",
        make_default: "Standaard maken",
        manage_limits: "Limieten beheren",
        manage_overrides: "Overrides beheren",
        manage_review: "Beheer Beoordeling",
        mcp_example_prompts: "Voorbeelden van prompts",
        mcp_server: "MCP Server",
        message: "Bericht",
        messages: "Berichten",
        meta: "Meta",
        no_clients: "Geen klanten",
        no_commissions: "Geen commissies",
        no_connected_apps: "Geen verbonden apps",
        no_custom_fields: "Geen aangepaste velden",
        no_customers: "Geen klanten",
        no_links: "Geen Koppelingen",
        no_locations: "Geen locaties",
        no_members: "Geen leden",
        no_messages: "Geen berichten",
        no_payouts: "Geen uitbetalingen",
        no_projects: "Geen projecten",
        no_qr_codes: "Geen QR-codes",
        no_referrals: "Geen doorverwijzingen",
        no_review_pages: "Geen beoordelingspagina's",
        no_reviews: "Geen Beoordelingen",
        no_tags: "Geen tags",
        no_team_members: "Geen teamleden",
        no_template: "Geen sjabloon",
        no_widgets: "Geen widgets",
        notifications: "Meldingen",
        options: "Opties",
        overview: "Overzicht",
        payment_method: "Betaalmethode",
        photo: "Foto",
        plans: "Plannen",
        powered_by: "Aangedreven door",
        pricing: "Prijzen",
        privacy_policy: "Privacybeleid",
        profile: "Profiel",
        project: "Project",
        project_limits: "Projectlimieten",
        project_overrides: "Projectoverschrijvingen",
        projects: "Projecten",
        qr_code: "QR-code",
        qr_codes: "QR-codes",
        ratings: "Scores",
        redeem_access_code: "Toegangscode inwisselen",
        redirecting: "Omleiden",
        redirects: "Omleidingen",
        referrals_commissions: "Commissies",
        referrals_payouts: "Uitbetalingen",
        referral_program: "Voorwaarden van het verwijzingsprogramma",
        reminders: "Herinneringen",
        reply: "Antwoord",
        request: "Verzoek",
        request_options: "Aanvraagopties",
        requests: "Verzoeken",
        required: "Vereist",
        reschedule_message: "Bericht opnieuw plannen",
        reset_password: "Wachtwoord opnieuw instellen",
        retries: "Opnieuw proberen",
        review: "Beoordeling",
        review_link: "Beoordelingslink",
        review_page: "Beoordelingspagina",
        review_pages: "Beoordelingspagina's",
        review_spotlight: "Uitgelichte beoordeling",
        review_suggestions: "Suggesties voor Beoordeling",
        review_wall: "Beoordelingsmuur",
        reviewer: "Beoordelaar",
        reviews: "Beoordelingen",
        save_changes: "Wijzigingen Opslaan",
        schedule: "Schema",
        scrape_a_website: "Website scrapen",
        search_engines: "Zoekmachines",
        sections: "Secties",
        select_csv_file: "Selecteer CSV -bestand",
        select_project: "Selecteer een project",
        selecting_project: "Project selecteren",
        sending_domain: "Domein verzenden",
        sending_limits: "Verzendlimieten",
        settings: "Instellingen",
        setup: "Instellen",
        setup_basics: "Uw Verzoek",
        setup_business: "Laten we beginnen",
        setup_google: "Uw Google Bedrijfsprofiel",
        setup_trusted: "Vertrouwd door meer dan 5.000 bedrijven",
        showcase: "Showcase",
        sign_up: "Aanmelden",
        signature: "Handtekening",
        signatures: "Handtekeningen",
        signing_in: "Aanmelden",
        single_sign_on: "Single sign-on",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS berichten",
        sms_usage: "SMS gebruik",
        smtp_configuration: "SMTP configuratie",
        source: "Bron",
        sources: "Bronnen",
        space: "Werkruimte",
        spaces: "Werkruimtes",
        stats: "Statistieken",
        sub_processors: "Subprocessors",
        success_page: "Succespagina",
        summary: "Samenvatting",
        tag: "Tag",
        tag_rule: "Tag-regel",
        tags: "Tags",
        team_members: "Teamleden",
        template: "Sjabloon",
        templates: "Sjablonen",
        terms_of_service: "Servicevoorwaarden",
        two_factor_authentication: "Twee-factorauthenticatie",
        unable_to_complete_request: "Verzoek kan niet worden voltooid",
        unique_review_link: "Unieke beoordelingslink",
        unsent_messages: "Niet verzonden berichten",
        unsubscribe: "Uitschrijven",
        update_plan: "Plan bijwerken",
        usage: "Gebruik",
        user: "Gebruiker",
        user_info: "Gebruikersinfo",
        verify_email_address: "E-mailadres verifiëren",
        verifying_email: "E-mail verifiëren",
        visibility: "Zichtbaarheid",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Website",
        white_label_api: "White Label API",
        white_label_client_portal: "White Label-klantenportaal",
        white_label_image_urls: "White Label-afbeeldings-URL's",
        white_label_sending_domain: "White Label Verzenddomein",
        white_label_widget_tag: "White Label Widget-tag",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Jouw plan"
    },
    tones: {
        apologetic: "Verontschuldigend",
        casual: "Casual",
        empathetic: "Empathisch",
        enthusiastic: "Enthousiast",
        formal: "Formeel",
        friendly: "Vriendelijk",
        grateful: "Dankbaar",
        humorous: "Humoristisch",
        informative: "Informatief"
    },
    widgets: {
        labels: {
            alignment: "Uitlijning",
            animation: "Animatie",
            autoplay: "Automatisch afspelen",
            autoplay_delay: "Vertraging automatisch afspelen",
            avatar: "Avatar",
            background_color: "Achtergrondkleur",
            border: "Grens",
            border_color: "Randkleur",
            border_radius: "Grensradius",
            border_width: "Randbreedte",
            carousel: "Carrousel",
            colors: "Kleuren",
            company: "Bedrijf",
            customer: "Klant",
            customer_position: "Klantpositie",
            date: "Datum",
            delay: "Vertraging",
            drop_shadow: "Slagschaduw",
            duration: "Duur",
            filters: "Filteren",
            font: "Lettertype",
            font_emphasis: "Lettertype nadruk",
            font_family: "Lettertypefamilie",
            font_size: "Lettergrootte",
            include_hidden: "Inclusief verborgen Beoordelingen",
            layout: "Indeling",
            limit: "Beoordelingen per pagina",
            location_ids: "Locaties",
            marquee: "Marquee",
            max_slides: "Maximale dia's",
            max_width: "Maximale breedte",
            name_convention: "Naam",
            padding: "Binnenafstand",
            pagination: "Paginering",
            quotes: "Citaten",
            rating: "Score",
            rating_round: "Afronding",
            rating_round_hundredth: "Afgerond op twee decimalen (4,94)",
            rating_round_tenth: "Afgerond op één decimaal (4,9)",
            review: "Beoordeling",
            review_chars: "Beoordeling Lengte",
            review_count: "Beoordeling aantal",
            review_id: "Beoordeling",
            review_ids: "Beoordelingen",
            review_ids_for_faces: "Beoordelingen voor Gezichten",
            reviews: "Beoordelingen",
            schema: "Schema",
            schema_name: "Bedrijfsnaam",
            schema_type: "Bedrijfstype",
            score: "Laagste beoordeling",
            show_on_mobile: "Weergeven op mobiel",
            slider: "Schuifregelaar",
            source: "Bron",
            source_ids: "Bronnen",
            source_position: "Bronpositie",
            speed: "Snelheid",
            star_color: "Ster kleur",
            star_display: "Sterrenbeeld",
            star_size: "Stergrootte",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tags",
            take: "Maximaal aantal Beoordelingen",
            text_color: "Tekstkleur",
            truncate: "Verkort Beoordeling",
            visible_slides: "Zichtbare dia's",
            width: "Breedte"
        },
        types: {
            badge: "Insigne",
            carousel: "Carrousel",
            carousel_dynamic: "Dynamische carrousel",
            corner: "Hoek",
            corner_dynamic: "Dynamische hoek",
            faces: "Gezichten",
            headline: "Kop",
            highlights: "Hoogtepunten",
            marquee: "Marquee",
            spotlight: "Uitgelicht",
            wall: "Muur"
        }
    }
}
